import { TextDecoration, TextCase, LineHeightUnit, LetterSpacingUnit, CharactersComponent, StartIndexComponent, EndIndexComponent, FontSizeComponent, FontNameComponent, FontStyleComponent, FontWeightComponent, TextDecorationComponent, TextCaseComponent, LineHeightUnitComponent, LineHeightValueComponent, LetterSpacingUnitComponent, LetterSpacingValueComponent, TextListOptionsComponent, IndetationComponent, TextAlignHorizontal, TextAlignVertical, StyledTextSegmentRelationsAspect, TextAlignHorizontalComponent, TextAlignVerticalComponent, TextAutoResizeComponent, TextTruncationComponent, StrokeAlign as StrokeAlign$1, NodeType as NodeType$1, getSize, getAnchorPoint, multipliedMatrices, TranslateMatrix, SweepAspect, CornerRadiusAspect, SmoothCornerRadiusComponent, IndividualCornerRadiusAspect, StrokesAspect, PolygonAspect, round as round$1, StarAspect, CornerRadiusComponent, VectorPathsComponent, SizeBehaviourComponent, ScaleMatrix, AnchorPointComponent, SizeComponent, TopLeftCornerRadiusComponent, TopRightCornerRadiusComponent, BottomRightCornerRadiusComponent, BottomLeftCornerRadiusComponent, StartAngleComponent, EndAngleComponent, InnerRadiusComponent, StrokeWeightComponent, PointCountComponent, TrimPathAspect, PathReversedComponent, ChildrenRelationsAspect, hasOwnAnimation, NodeTypeComponent, NameComponent, VisibleInViewportComponent, DurationComponent, getStartTime, getEndTime, isIndividualStrokesAvailable, isIndividualStrokesEnabled, ClipContentComponent, ZIndexAspect, MaskComponent, BlendModeComponent, EffectsRelationsAspect, EffectTypeComponent, EffectType as EffectType$1, getAnimatableValue, ShadowColorComponent, ShadowOffsetComponent, ShadowRadiusComponent, ShadowSpreadComponent, BlurRadiusComponent, FillsRelationsAspect, PaintTypeComponent, PaintType as PaintType$1, HashComponent, getPosition, getRotation, getOpacity, getScale, LayoutAspect, getTransformMatrix, getAbsoluteTransformMatrix, ScaleComponent, StrokesRelationsAspect, StrokeAlignComponent, StrokeJoinComponent, StrokeJoin as StrokeJoin$1, StrokeCapStartComponent, StrokeCap as StrokeCap$1, StrokeCapEndComponent, DashOffsetComponent, DashComponent, GapComponent, IndividualStrokeWeightAspect, BlendModeType as BlendModeType$1, OpacityComponent, ScaleTypeComponent, ImageTransformComponent, ScalingFactorComponent, RotationComponent, GradientTransformComponent, ColorStopsRelationsAspect, RgbaValueComponent, ProgressComponent, StartTimeComponent, getSortedKeyframes, TimeComponent, getClosestSegment, EntryComponent, UpdatesSystem } from '@aninix-inc/model';
import * as React from 'react';
import React__default, { createContext, useContext } from 'react';
import * as R from 'ramda';
import paper from 'paper';
export { default as paper } from 'paper';
import * as math from 'mathjs';
import { renderToStaticMarkup } from 'react-dom/server';

const createTextStyle = (segmentMeta, node) => ({
    fontSize: `${segmentMeta.fontSize}px`,
    fontFamily: segmentMeta.fontName,
    fontStyle: segmentMeta.fontStyle,
    fontWeight: segmentMeta.fontWeight,
    textDecoration: segmentMeta.textDecoration === TextDecoration.None
        ? 'none'
        : segmentMeta.textDecoration === TextDecoration.Underline
            ? 'underline'
            : 'line-through',
    textTransform: segmentMeta.textCase === TextCase.Original
        ? 'none'
        : segmentMeta.textCase === TextCase.Upper
            ? 'uppercase'
            : segmentMeta.textCase === TextCase.Lower
                ? 'lowercase'
                : segmentMeta.textCase === TextCase.Title
                    ? 'capitalize'
                    : 'none',
    lineHeight: segmentMeta.lineHeightUnit === LineHeightUnit.Auto
        ? 'normal'
        : segmentMeta.lineHeightUnit === LineHeightUnit.Pixels
            ? `${segmentMeta.lineHeightValue}px`
            : `${segmentMeta.lineHeightValue}%`,
    letterSpacing: segmentMeta.letterSpacingValue === 0
        ? '0px'
        : segmentMeta.letterSpacingUnit === LetterSpacingUnit.Pixels
            ? `${segmentMeta.letterSpacingValue * 1.1}px`
            : `${(segmentMeta.fontSize * segmentMeta.letterSpacingValue) / 100}px`,
    strokeWidth: node.strokes[0]?.type === 'solid' ? `${node.strokes[0].color}px` : '0',
    fontOpticalSizing: segmentMeta.letterSpacingValue !== 0 &&
        segmentMeta.letterSpacingUnit === LetterSpacingUnit.Pixels
        ? undefined
        : 'none',
    // fontOpticalSizing: 'none',
});

const extractSegmentMeta = (segment) => ({
    characters: segment.getComponentOrThrow(CharactersComponent).value,
    startIndex: segment.getComponentOrThrow(StartIndexComponent).value,
    endIndex: segment.getComponentOrThrow(EndIndexComponent).value,
    fontSize: segment.getComponentOrThrow(FontSizeComponent).value,
    fontName: segment.getComponentOrThrow(FontNameComponent).value,
    fontStyle: segment
        .getComponentOrThrow(FontStyleComponent)
        .value.includes('Italic')
        ? 'italic'
        : 'normal',
    fontWeight: segment.getComponentOrThrow(FontWeightComponent).value,
    textDecoration: segment.getComponentOrThrow(TextDecorationComponent).value,
    textCase: segment.getComponentOrThrow(TextCaseComponent).value,
    lineHeightUnit: segment.getComponentOrThrow(LineHeightUnitComponent).value,
    lineHeightValue: segment.getComponentOrThrow(LineHeightValueComponent).value,
    letterSpacingUnit: segment.getComponentOrThrow(LetterSpacingUnitComponent)
        .value,
    letterSpacingValue: segment.getComponentOrThrow(LetterSpacingValueComponent)
        .value,
    textListOptions: segment.getComponentOrThrow(TextListOptionsComponent).value,
    indetation: segment.getComponentOrThrow(IndetationComponent).value,
});

const mapHorizontalAlign = (align) => {
    switch (align) {
        case TextAlignHorizontal.Left:
            return 'left';
        case TextAlignHorizontal.Center:
            return 'center';
        case TextAlignHorizontal.Right:
            return 'right';
        case TextAlignHorizontal.Justified:
            return 'justify';
        default:
            return 'left';
    }
};

const mapVerticalAlign = (align) => {
    switch (align) {
        case TextAlignVertical.Top:
            return 'top';
        case TextAlignVertical.Center:
            return 'center';
        case TextAlignVertical.Bottom:
            return 'bottom';
        default:
            return 'baseline';
    }
};

const MeasureParagraph = ({ node }) => {
    const { id, entity, size } = node;
    const styledSegments = entity
        .getAspect(StyledTextSegmentRelationsAspect)
        ?.getChildrenList();
    if (!styledSegments || styledSegments.length === 0)
        return null;
    const paragraphMeta = {
        alignHorizontal: entity.getComponentOrThrow(TextAlignHorizontalComponent)
            .value,
        alignVertical: entity.getComponentOrThrow(TextAlignVerticalComponent).value,
        autoResize: entity.getComponentOrThrow(TextAutoResizeComponent).value,
        truncation: entity.getComponentOrThrow(TextTruncationComponent).value,
    };
    const paragraphStyle = {
        margin: 'auto',
        width: `${size.x}px`,
        height: `${size.y}px`,
        textAlign: mapHorizontalAlign(paragraphMeta.alignHorizontal),
        alignContent: mapVerticalAlign(paragraphMeta.alignVertical),
        whiteSpace: paragraphMeta.autoResize ? 'normal' : 'nowrap',
        overflow: paragraphMeta.truncation ? 'hidden' : 'visible',
        textOverflow: paragraphMeta.truncation ? 'ellipsis' : 'clip',
        dominantBaseline: 'hanging',
    };
    return (React.createElement("p", { id: `measure-${id}`, style: paragraphStyle }, styledSegments.map((segment, index) => {
        const segmentMeta = extractSegmentMeta(segment);
        const segmentStyle = createTextStyle(segmentMeta, node);
        return (React.createElement("span", { key: index, id: `segment-${segment.id}`, style: segmentStyle }, segmentMeta.characters));
    })));
};

async function loadInlineFonts(url) {
    if (!checkBrowserRequirements()) {
        throw new Error('Sorry, current browser does not support required features.');
    }
    if (!verifyURL(url)) {
        throw new Error('Invalid Google Fonts CSS URL');
    }
    try {
        const cssText = await fetchCSS(url);
        return await embedFonts(cssText);
    }
    catch (error) {
        console.error('Error loading inline fonts:', error);
        throw error;
    }
}
function checkBrowserRequirements() {
    return (typeof window.fetch !== 'undefined' &&
        typeof window.FileReader !== 'undefined' &&
        typeof window.URL !== 'undefined');
}
function verifyURL(url) {
    return url.startsWith('https://fonts.googleapis.com/');
}
async function fetchCSS(url) {
    const response = await fetch(url);
    return response.text();
}
async function embedFonts(cssText) {
    const fontLocations = cssText.match(/https:\/\/[^)]+/g) || [];
    let modifiedCssText = cssText;
    const fontLoadedPromises = fontLocations.map(async (location) => {
        const response = await fetch(location);
        const blob = await response.blob();
        const dataUrl = await blobToDataURL(blob);
        modifiedCssText = modifiedCssText.replace(new RegExp(location, 'g'), dataUrl);
        return [location, dataUrl];
    });
    await Promise.all(fontLoadedPromises);
    return modifiedCssText;
}
function blobToDataURL(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}

/**
 * Prepare paperjs to use.
 * It requires `document` to be in scope.
 * Please **USE** paper only from import from this package.
 * Otherwise it can cause unexpected issues with different scopes.
 */
const canvas = document.createElement('canvas');
paper.setup(canvas);
paper.settings.insertItems = false;

function safeString$1(string) {
    // return string
    return string.replace(/[^A-Za-z0-9]/g, '');
}
function generateId() {
    const part1 = Date.now().toString(36);
    const part2 = Math.random().toString(36).substring(2);
    return `${part1}${part2}`;
}
function mapWindingRule(windingRule) {
    if (windingRule === 'EVENODD') {
        return 'evenodd';
    }
    if (windingRule === 'NONZERO') {
        return 'nonzero';
    }
    return 'nonzero';
}
/**
 * @description applying transform matrix as inverted affine transform
 * @param transform matrix
 * @param initial matrix
 * @returns coefficients for point to next operations
 */
function getPointCoefficient$2(transform, initial) {
    // @NOTE: required in odd cases when project receive invalid values for gradient transform
    const isMatrixInvalid = R.all((row) => R.all((item) => item === 0, row), transform);
    if (isMatrixInvalid) {
        return { x: 0, y: 0 };
    }
    const transformMatrix = math.matrix([...transform, [0, 0, 1]]);
    const invertedTransformMatrix = math.inv(transformMatrix);
    const [x, y] = math
        .multiply(invertedTransformMatrix, math.matrix(initial))
        .toArray();
    return { x, y };
}

const OFFSET_IN_PERCENTS$3 = 0.2;
function isVisible(node) {
    const isPaintsVisible = [...node.fills, ...node.strokes].filter((fill) => {
        if (!fill.visible) {
            return false;
        }
        if (fill.type === 'solid') {
            return fill.color.a !== 0;
        }
        return fill.opacity !== 0;
    }).length !== 0;
    return isPaintsVisible && node.opacity !== 0;
}
const BackgroundBlur = ({ node, blurs, BlurContent, children }) => {
    const clipContentId = React.useRef(generateId());
    if (node == null ||
        blurs == null ||
        blurs.filter((bgBlur) => bgBlur.visible).length === 0 ||
        node.data.length === 0) {
        return React.createElement(React.Fragment, null, children);
    }
    if (!isVisible(node)) {
        return React.createElement(React.Fragment, null, children);
    }
    const expansionPercentage = Math.max(...blurs.map((s) => s.radius)) /
        Math.min(node.size.x, node.size.y) +
        OFFSET_IN_PERCENTS$3;
    return (React.createElement(React.Fragment, null,
        React.createElement("defs", null,
            React.createElement("filter", { id: blurs[0].id, x: `-${expansionPercentage * 100}%`, y: `-${expansionPercentage * 100}%`, width: `${(expansionPercentage * 2 + 1) * 100}%`, height: `${(expansionPercentage * 2 + 1) * 100}%`, filterRes: 0.5, filterUnits: "objectBoundingBox" },
                React.createElement("feGaussianBlur", { key: blurs[0].id, 
                    // @NOTE: because figma divide it by coefficient
                    stdDeviation: blurs[0].radius / 2, result: "blurredImage" }),
                React.createElement("feComponentTransfer", { in: "blurredImage", result: "opaqueBlur" },
                    React.createElement("feFuncA", { type: "table", tableValues: "1 1 1 1" }))),
            React.createElement("clipPath", { id: clipContentId.current }, node.data.map((vectorPath, idx) => (React.createElement("path", { key: idx, transform: `matrix(${node.absoluteTransformMatrix.values})`, d: vectorPath.data, clipRule: mapWindingRule(vectorPath.windingRule) }))))),
        React.createElement("g", { 
            // filter={`url(#${snapshot.backgroundBlurs[0].id})`}
            transform: `matrix(${R.defaultTo(
            // @NOTE: default required here in case when inverted matrix doesn't exists (some rare cases)
            [1, 0, 0, 0, 1, 0], node.absoluteTransformMatrix.inverted()?.values)})`, clipPath: `url(#${clipContentId.current})`, style: {
                filter: `blur(${blurs[0].radius / 2}px)`,
                // filter: `url(#${snapshot.backgroundBlurs[0].id})`,
            } }, BlurContent),
        React.createElement("g", null, children)));
};
BackgroundBlur.displayName = 'BackgroundBlur';

const OFFSET_IN_PERCENTS$2 = 0.2;
const DropShadows = ({ node, shadows }) => {
    if (node == null) {
        return null;
    }
    const expansionPercentage = Math.max(...shadows.map((s) => s.radius)) /
        Math.min(node.size.x, node.size.y) +
        OFFSET_IN_PERCENTS$2;
    const xOffset = Math.max(...shadows.map((s) => s.offset.x)) / node.size.x -
        expansionPercentage;
    const yOffset = Math.max(...shadows.map((s) => s.offset.y)) / node.size.y -
        expansionPercentage;
    return (React.createElement(React.Fragment, null,
        React.createElement("defs", null,
            React.createElement("filter", { "data-id": "hello-world", id: shadows[0].id, x: `${xOffset * 100}%`, y: `${yOffset * 100}%`, width: `${(expansionPercentage * 2 + 1) * 100}%`, height: `${(expansionPercentage * 2 + 1) * 100}%`, filterUnits: "objectBoundingBox" },
                shadows.map((shadow) => (React.createElement(React.Fragment, { key: shadow.id },
                    React.createElement("feOffset", { 
                        // @NOTE: id required to apply animated properties
                        id: `${shadow.id}_offset`, dx: shadow.offset.x, dy: shadow.offset.y, in: "SourceGraphic", result: `${shadow.id}_offset` }),
                    React.createElement("feGaussianBlur", { 
                        // @NOTE: id required to apply animated properties
                        id: `${shadow.id}_radius`, 
                        // @NOTE: because figma divide it by coefficient
                        stdDeviation: shadow.radius / 2, in: `${shadow.id}_offset`, result: `${shadow.id}_blur` }),
                    React.createElement("feFlood", { floodColor: `rgb(${shadow.color.r} ${shadow.color.g} ${shadow.color.b})`, floodOpacity: shadow.color.a, in: `${shadow.id}_blur`, result: `${shadow.id}_color` }),
                    React.createElement("feComposite", { operator: "in", in: `${shadow.id}_color`, in2: `${shadow.id}_blur`, result: `${shadow.id}_shadow_result` })))),
                React.createElement("feMerge", null,
                    shadows.map((shadow) => (React.createElement("feMergeNode", { key: shadow.id, in: `${shadow.id}_shadow_result` }))),
                    React.createElement("feMergeNode", { in: "SourceGraphic" }))))));
};
DropShadows.displayName = 'DropShadows';

var NodeType;
(function (NodeType) {
    NodeType["Generic"] = "GENERIC";
    NodeType["BooleanOperation"] = "BOOLEAN_OPERATION";
    NodeType["Component"] = "COMPONENT";
    // ComponentSet = 'COMPONENT_SET',
    // Document = 'DOCUMENT',
    NodeType["Ellipse"] = "ELLIPSE";
    NodeType["Instance"] = "INSTANCE";
    NodeType["Frame"] = "FRAME";
    NodeType["Group"] = "GROUP";
    NodeType["Line"] = "LINE";
    // Page = 'PAGE',
    NodeType["Polygon"] = "POLYGON";
    NodeType["Rectangle"] = "RECTANGLE";
    // Slice = 'SLICE',
    NodeType["Star"] = "STAR";
    NodeType["Text"] = "TEXT";
    NodeType["Vector"] = "VECTOR";
})(NodeType || (NodeType = {}));
/**
 * Previously has name `ModelType`
 */
var EntityType;
(function (EntityType) {
    EntityType["Root"] = "root";
    EntityType["Node"] = "node";
    EntityType["Keyframe"] = "keyframe";
    /**
     * Previously has name `property-group`
     */
    EntityType["Effect"] = "effect";
    /**
     * Previously has name `property-group`
     */
    EntityType["Paint"] = "paint";
    EntityType["ExportPreset"] = "export-preset";
    EntityType["CurveStyle"] = "curve-style";
    EntityType["ColorStop"] = "color-stop";
})(EntityType || (EntityType = {}));
/**
 * @description predefined list of available layer colors
 */
var LayerColor;
(function (LayerColor) {
    LayerColor["Blue"] = "BLUE";
    LayerColor["Purple"] = "PURPLE";
    LayerColor["Pink"] = "PINK";
    LayerColor["Green"] = "GREEN";
    LayerColor["Turqouise"] = "TURQOUISE";
    LayerColor["Red"] = "RED";
    LayerColor["Orange"] = "ORANGE";
    LayerColor["Yellow"] = "YELLOW";
    LayerColor["Grey"] = "GREY";
    LayerColor["None"] = "NONE";
})(LayerColor || (LayerColor = {}));
var RenderType;
(function (RenderType) {
    RenderType["mp4"] = "mp4";
    RenderType["webm"] = "webm";
    RenderType["ogv"] = "ogv";
    // lottie json file
    RenderType["lottie"] = "lottie";
    // dotLottie file
    RenderType["dotLottie"] = "dotlottie";
    // telegram stickers
    RenderType["tgs"] = "tgs";
    // animated svg
    RenderType["svg"] = "svg";
    // animated gif
    RenderType["gif"] = "gif";
    // png sequence
    RenderType["png"] = "png";
})(RenderType || (RenderType = {}));
var RenderScaleType;
(function (RenderScaleType) {
    RenderScaleType["0.5x"] = "0.5x";
    RenderScaleType["0.75x"] = "0.75x";
    RenderScaleType["1x"] = "1x";
    RenderScaleType["1.5x"] = "1.5x";
    RenderScaleType["2x"] = "2x";
    RenderScaleType["3x"] = "3x";
    RenderScaleType["4x"] = "4x";
})(RenderScaleType || (RenderScaleType = {}));
/**
 * @description used to determine where node should be set to solo
 * None – solo disabled
 * Viewport – node will be isolated in viewport only
 * Timeline – node will be isolated on timeline only
 * Both – node will be isolaterd in viewport and on timeline
 */
var NodeSoloType;
(function (NodeSoloType) {
    NodeSoloType["None"] = "NONE";
    NodeSoloType["Viewport"] = "VIEWPORT";
    NodeSoloType["Timeline"] = "TIMELINE";
    NodeSoloType["Both"] = "BOTH";
})(NodeSoloType || (NodeSoloType = {}));
var PaintType;
(function (PaintType) {
    PaintType["Solid"] = "SOLID";
    PaintType["GradientLinear"] = "GRADIENT_LINEAR";
    PaintType["GradientRadial"] = "GRADIENT_RADIAL";
    // GradientAngular = 'GRADIENT_ANGULAR',
    // GradientDiamond = 'GRADIENT_DIAMOND',
    PaintType["Image"] = "IMAGE";
})(PaintType || (PaintType = {}));
var ScaleType;
(function (ScaleType) {
    ScaleType["Fill"] = "FILL";
    ScaleType["Fit"] = "FIT";
    ScaleType["Crop"] = "CROP";
    ScaleType["Tile"] = "TILE";
})(ScaleType || (ScaleType = {}));
var EffectType;
(function (EffectType) {
    EffectType["DropShadow"] = "DROP_SHADOW";
    EffectType["LayerBlur"] = "LAYER_BLUR";
    EffectType["BackgroundBlur"] = "BACKGROUND_BLUR";
    EffectType["InnerShadow"] = "INNER_SHADOW";
})(EffectType || (EffectType = {}));
var BlendModeType;
(function (BlendModeType) {
    BlendModeType["PassThrough"] = "PASS_THROUGH";
    BlendModeType["Normal"] = "NORMAL";
    BlendModeType["Darken"] = "DARKEN";
    BlendModeType["Multiply"] = "MULTIPLY";
    BlendModeType["LinearBurn"] = "LINEAR_BURN";
    BlendModeType["ColorBurn"] = "COLOR_BURN";
    BlendModeType["Lighten"] = "LIGHTEN";
    BlendModeType["Screen"] = "SCREEN";
    BlendModeType["LinearDodge"] = "LINEAR_DODGE";
    BlendModeType["ColorDodge"] = "COLOR_DODGE";
    BlendModeType["Overlay"] = "OVERLAY";
    BlendModeType["SoftLight"] = "SOFT_LIGHT";
    BlendModeType["HardLight"] = "HARD_LIGHT";
    BlendModeType["Difference"] = "DIFFERENCE";
    BlendModeType["Exclusion"] = "EXCLUSION";
    BlendModeType["Hue"] = "HUE";
    BlendModeType["Saturation"] = "SATURATION";
    BlendModeType["Color"] = "COLOR";
    BlendModeType["Luminosity"] = "LUMINOSITY";
})(BlendModeType || (BlendModeType = {}));
var StrokeAlign;
(function (StrokeAlign) {
    StrokeAlign["Center"] = "CENTER";
    StrokeAlign["Inside"] = "INSIDE";
    StrokeAlign["Outside"] = "OUTSIDE";
})(StrokeAlign || (StrokeAlign = {}));
var StrokeCap;
(function (StrokeCap) {
    StrokeCap["None"] = "NONE";
    StrokeCap["Round"] = "ROUND";
    StrokeCap["Square"] = "SQUARE";
    StrokeCap["ArrowLines"] = "ARROW_LINES";
    StrokeCap["ArrowEquilateral"] = "ARROW_EQUILATERAL";
    StrokeCap["TriangleFilled"] = "TRIANGLE_FILLED";
    StrokeCap["DiamondFilled"] = "DIAMOND_FILLED";
    StrokeCap["CircleFilled"] = "CIRCLE_FILLED";
})(StrokeCap || (StrokeCap = {}));
var StrokeJoin;
(function (StrokeJoin) {
    StrokeJoin["Miter"] = "MITER";
    StrokeJoin["Bevel"] = "BEVEL";
    StrokeJoin["Round"] = "ROUND";
})(StrokeJoin || (StrokeJoin = {}));
var BooleanOperationType;
(function (BooleanOperationType) {
    BooleanOperationType["Union"] = "UNION";
    BooleanOperationType["Intersect"] = "INTERSECT";
    BooleanOperationType["Subtract"] = "SUBTRACT";
    BooleanOperationType["Exclude"] = "EXCLUDE";
})(BooleanOperationType || (BooleanOperationType = {}));
var CurveType;
(function (CurveType) {
    CurveType["Spring"] = "SPRING";
    CurveType["Timing"] = "TIMING";
})(CurveType || (CurveType = {}));
var NodeSizeBehaviour;
(function (NodeSizeBehaviour) {
    /**
     * @description fill all available space
     */
    NodeSizeBehaviour["Fill"] = "FILL";
    /**
     * @description not react on size changes
     */
    NodeSizeBehaviour["Ignore"] = "IGNORE";
})(NodeSizeBehaviour || (NodeSizeBehaviour = {}));

/**
 * @description applying transform matrix as inverted affine transform
 * @param transform matrix
 * @param initial matrix
 * @returns coefficients for point to next operations
 */
function getPointCoefficient$1(transform, initial) {
    const transformMatrix = math.matrix([...transform, [0, 0, 1]]);
    const invertedTransformMatrix = math.inv(transformMatrix);
    const [x, y] = math
        .multiply(invertedTransformMatrix, math.matrix(initial))
        .toArray();
    return { x, y };
}
function getSizeToFill({ target, actual }) {
    const targetRatio = target.x / target.y;
    const actualRatio = actual.x / actual.y;
    if (targetRatio < actualRatio) {
        const coefficient = target.y / actual.y;
        return {
            x: actual.x * coefficient,
            y: target.y,
        };
    }
    const coefficient = target.x / actual.x;
    return {
        x: target.x,
        y: actual.y * coefficient,
    };
}
function getSizeToFit({ target, actual }) {
    const targetRatio = target.x / target.y;
    const actualRatio = actual.x / actual.y;
    if (targetRatio < actualRatio) {
        const coefficient = target.x / actual.x;
        return {
            x: target.x,
            y: actual.y * coefficient,
        };
    }
    const coefficient = target.y / actual.y;
    return {
        x: actual.x * coefficient,
        y: target.y,
    };
}
/**
 * @todo add support of image filters https://www.figma.com/plugin-docs/api/Paint/#filters
 */
const Image$1 = ({ size, opacity, scaleMode, image, imageTransform, scalingFactor, rotation, pathId, pathType: type = 'clip', }) => {
    if (image.loaded === false) {
        return null;
    }
    if (scaleMode === 'FILL') {
        const newSize = getSizeToFill({
            target: size,
            actual: image.size,
        });
        // @NOTE: required to fix positioning when figma image is rotated
        const newPosition = (() => {
            if (Math.sign(newSize.x) === -1) {
                return {
                    x: -(newSize.x - size.x) / 2 + newSize.x,
                    y: -(newSize.y - size.y) / 2,
                };
            }
            if (Math.sign(newSize.y) === -1) {
                return {
                    x: -(newSize.x - size.x) / 2,
                    y: -(newSize.y - size.y) / 2 + newSize.y,
                };
            }
            return {
                x: -(newSize.x - size.x) / 2,
                y: -(newSize.y - size.y) / 2,
            };
        })();
        return (React.createElement("image", { x: newPosition.x, y: newPosition.y, width: Math.abs(newSize.x), height: Math.abs(newSize.y), href: image.src, opacity: opacity, rotate: rotation, clipPath: type === 'clip' ? `url(#${pathId})` : undefined, mask: type === 'mask' ? `url(#${pathId})` : undefined }));
    }
    if (scaleMode === 'FIT') {
        const newSize = getSizeToFit({
            target: size,
            actual: image.size,
        });
        // @NOTE: required to fix positioning when figma image is rotated
        const newPosition = (() => {
            if (Math.sign(newSize.x) === -1) {
                return {
                    x: -(newSize.x - size.x) / 2 + newSize.x,
                    y: -(newSize.y - size.y) / 2,
                };
            }
            if (Math.sign(newSize.y) === -1) {
                return {
                    x: -(newSize.x - size.x) / 2,
                    y: -(newSize.y - size.y) / 2 + newSize.y,
                };
            }
            return {
                x: -(newSize.x - size.x) / 2,
                y: -(newSize.y - size.y) / 2,
            };
        })();
        return (React.createElement("image", { x: newPosition.x, y: newPosition.y, width: Math.abs(newSize.x), height: Math.abs(newSize.y), href: image.src, opacity: opacity, rotate: rotation, clipPath: type === 'clip' ? `url(#${pathId})` : undefined, mask: type === 'mask' ? `url(#${pathId})` : undefined }));
    }
    if (scaleMode === 'TILE') {
        const newSize = {
            x: image.size.x * scalingFactor,
            y: image.size.y * scalingFactor,
        };
        const rows = Math.floor(size.x / newSize.x) + 1;
        const columns = Math.floor(size.y / newSize.y) + 1;
        const table = R.range(0, rows).map(() => R.range(0, columns));
        return (React.createElement(React.Fragment, null, table.map((item, row) => item.map((column) => (React.createElement("image", { key: `${row}-${column}`, x: newSize.x * row, y: newSize.y * column, width: newSize.x, height: newSize.y, href: image.src, opacity: opacity, rotate: rotation, clipPath: type === 'clip' ? `url(#${pathId})` : undefined, mask: type === 'mask' ? `url(#${pathId})` : undefined }))))));
    }
    if (scaleMode === 'CROP') {
        // const newCoef = getPointCoefficient(toJS(imageTransform), [0, 0, 1]);
        const newCoef = getPointCoefficient$1(imageTransform, [0, 0, 1]);
        const invertedTransformMatrix = math
            .inv(math.matrix([...imageTransform, [0, 0, 1]]))
            .toArray();
        return (React.createElement("image", { x: size.x * newCoef.x, y: size.y * newCoef.y, width: size.x * invertedTransformMatrix[0][0], height: size.y * invertedTransformMatrix[1][1], href: image.src, opacity: opacity, rotate: rotation, clipPath: type === 'clip' ? `url(#${pathId})` : undefined, mask: type === 'mask' ? `url(#${pathId})` : undefined, preserveAspectRatio: "none" }));
    }
    return null;
};
Image$1.displayName = 'Image';

function map3x2to6x1Matrix(matrix) {
    const a = matrix[0][0];
    const b = matrix[1][0];
    const tx = matrix[0][2];
    const c = matrix[0][1];
    const d = matrix[1][1];
    const ty = matrix[1][2];
    return [a, b, c, d, tx, ty];
}
function map6x1to3x2Matrix(matrix) {
    const a = matrix[0];
    const b = matrix[1];
    const tx = matrix[4];
    const c = matrix[2];
    const d = matrix[3];
    const ty = matrix[5];
    return [
        [a, c, tx],
        [b, d, ty],
    ];
}
function inverted6x1Matrix(matrix) {
    try {
        const prepared = [...map6x1to3x2Matrix(matrix), [0, 0, 1]];
        const inverted = math.inv(math.matrix(prepared));
        return map3x2to6x1Matrix(inverted.toArray());
    }
    catch (err) {
        console.warn('!!! Cannot calculate determinant');
        return matrix;
    }
}
function svgMatrix(matrix) {
    return `matrix(${matrix.join(',')})`;
}
/**
 * @todo add support of blending modes
 */
const Fills = ({ node }) => {
    const { fills: paints, size, fillData: vectorPaths } = node;
    const mappedPaints = paints
        .filter((paint) => paint.visible === true)
        .map((paint) => {
        if (paint.type === 'image') {
            const image = paint.image;
            // @NOTE: image not loaded yet
            if (image == null || image.loaded === false) {
                return null;
            }
            return {
                id: paint.id,
                type: PaintType.Image,
                visible: paint.visible,
                opacity: paint.opacity,
                scaleMode: paint.scaleMode,
                image: image,
                imageTransform: paint.imageTransform,
                scalingFactor: paint.scalingFactor,
                rotation: paint.rotation,
                blendMode: paint.blendMode,
            };
        }
        if (paint.type === 'solid') {
            return {
                id: paint.id,
                type: PaintType.Solid,
                visible: paint.visible,
                color: paint.color,
                blendMode: paint.blendMode,
            };
        }
        if (paint.type === 'linear-gradient') {
            return {
                id: paint.id,
                type: PaintType.GradientLinear,
                visible: paint.visible,
                gradientTransform: paint.gradientTransform,
                colorStops: paint.colorStops,
                opacity: paint.opacity,
                blendMode: paint.blendMode,
            };
        }
        if (paint.type === 'radial-gradient') {
            return {
                id: paint.id,
                type: PaintType.GradientRadial,
                visible: paint.visible,
                gradientTransform: paint.gradientTransform,
                colorStops: paint.colorStops,
                opacity: paint.opacity,
                blendMode: paint.blendMode,
            };
        }
        return null;
    })
        .map((paint, idx) => {
        if (paint == null) {
            const iconSize = size.x / 4;
            const position = {
                x: (size.x - iconSize) / 2,
                y: (size.y - iconSize) / 2,
            };
            return (React.createElement("g", { key: idx, stroke: "#7F7F7F", strokeWidth: 2, fill: "none", strokeLinecap: "round", transform: `translate(${position.x} ${position.y})` },
                React.createElement("rect", { x: "0", y: "0", width: iconSize, height: iconSize, rx: 4 }),
                React.createElement("line", { x1: iconSize, y1: 0, x2: 0, y2: iconSize })));
        }
        if (paint.visible === false) {
            return null;
        }
        if (paint.type === PaintType.Image) {
            const clipPathId = `${safeString$1(node.id)}_${safeString$1(paint.id)}_clip_path`;
            return (React.createElement("g", { key: idx, style: {
                    mixBlendMode: paint.blendMode,
                } },
                React.createElement("defs", null,
                    React.createElement("clipPath", { id: clipPathId, clipPathUnits: "userSpaceOnUse" }, vectorPaths.map((vectorPath, idx) => (React.createElement("path", { key: idx, id: `${safeString$1(node.id)}_fill_path`, d: vectorPath.data, clipRule: mapWindingRule(vectorPath.windingRule) }))))),
                React.createElement(Image$1, { key: idx, image: paint.image, size: size, opacity: paint.opacity, scaleMode: paint.scaleMode, imageTransform: paint.imageTransform, scalingFactor: paint.scalingFactor, rotation: paint.rotation, pathId: clipPathId })));
        }
        if (paint.type === PaintType.Solid) {
            // @TODO: add support of blending mode
            return (React.createElement(React.Fragment, { key: idx }, vectorPaths.map((vectorPath, i) => (React.createElement("path", { key: i, id: `${safeString$1(node.id)}_fill_path`, d: vectorPath.data, fillRule: mapWindingRule(vectorPath.windingRule), fill: `rgb(${paint.color.r}, ${paint.color.g}, ${paint.color.b})`, fillOpacity: paint.color.a, style: {
                    mixBlendMode: paint.blendMode,
                } })))));
        }
        if (paint.type === PaintType.GradientLinear) {
            return (React.createElement("g", { key: idx, style: {
                    mixBlendMode: paint.blendMode,
                } },
                React.createElement("defs", null,
                    React.createElement("linearGradient", { id: safeString$1(paint.id), x1: "0", y1: "0.5", x2: "1", y2: "0.5", gradientTransform: svgMatrix(inverted6x1Matrix(map3x2to6x1Matrix(paint.gradientTransform))), gradientUnits: "objectBoundingBox" }, paint.colorStops.map((colorStop, idx) => (React.createElement("stop", { key: idx, offset: `${colorStop.position * 100}%`, stopOpacity: colorStop.color.a * paint.opacity, stopColor: `rgb(${colorStop.color.r}, ${colorStop.color.g}, ${colorStop.color.b})` }))))),
                vectorPaths.map((vectorPath, idx) => (React.createElement("path", { key: idx, id: `${safeString$1(node.id)}_fill_path`, d: vectorPath.data, fillRule: mapWindingRule(vectorPath.windingRule), fill: `url(#${safeString$1(paint.id)})` })))));
        }
        // @NOTE: there is a lot of small hacks which are not intuitive but that's how Figma works
        if (paint.type === PaintType.GradientRadial) {
            return (React.createElement("g", { key: idx, style: {
                    mixBlendMode: paint.blendMode,
                } },
                React.createElement("defs", null,
                    React.createElement("radialGradient", { id: safeString$1(paint.id), cx: 0.5, cy: 0.5, r: 0.5, gradientTransform: svgMatrix(inverted6x1Matrix(map3x2to6x1Matrix(paint.gradientTransform))), gradientUnits: "objectBoundingBox" }, paint.colorStops.map((colorStop, idx) => (React.createElement("stop", { key: idx, offset: `${colorStop.position * 100}%`, stopOpacity: colorStop.color.a * paint.opacity, stopColor: `rgb(${colorStop.color.r}, ${colorStop.color.g}, ${colorStop.color.b})` }))))),
                vectorPaths.map((vectorPath, idx) => (React.createElement("path", { key: idx, id: `${safeString$1(node.id)}_fill_path`, d: vectorPath.data, fillRule: mapWindingRule(vectorPath.windingRule), fill: `url(#${safeString$1(paint.id)})` })))));
        }
        return null;
    })
        .filter((f) => f != null);
    if (mappedPaints.length === 0) {
        return null;
    }
    return React.createElement(React.Fragment, null, mappedPaints);
};
Fills.displayName = 'Fills';

function mapPaperMatrixToModel(matrix) {
    const v = matrix.values;
    return [
        [v[0], v[1], v[4]],
        [v[2], v[3], v[5]],
    ];
}
const getRoundHead = (payload) => {
    return {
        path: new paper.Path.Circle(new paper.Point(0, 0), payload.size / 2)
            .pathData,
        matrix: mapPaperMatrixToModel(payload.matrix),
    };
};
const getSquareHead = (payload) => {
    const initialMatrix = (() => {
        const m = new paper.Matrix();
        m.translate(-1, -payload.size / 2);
        return m;
    })();
    return {
        path: new paper.Path.Rectangle(new paper.Point(0, 0), new paper.Size(payload.size, payload.size)).pathData,
        matrix: mapPaperMatrixToModel(payload.matrix.append(initialMatrix)),
    };
};
const getLineArrowHead = (payload) => {
    const initialMatrix = (() => {
        const m = new paper.Matrix();
        m.translate(-3.5, -5);
        m.scale(payload.size, new paper.Point(3.5, 5));
        return m;
    })();
    return {
        path: 'M3.3095 4.5L0.3255 1.457C0.1315 1.26 0.1355 0.942998 0.3315 0.749998C0.5295 0.556998 0.8455 0.559998 1.0385 0.756998L4.8575 4.65C5.0475 4.844 5.0475 5.156 4.8575 5.35L1.0385 9.243C0.8455 9.44 0.5285 9.443 0.3315 9.25C0.1345 9.057 0.1315 8.74 0.3255 8.543L3.3095 5.5V4.5Z',
        matrix: mapPaperMatrixToModel(payload.matrix.appended(initialMatrix)),
    };
};
const getTriangleArrowHead = (payload) => {
    const initialMatrix = (() => {
        const m = new paper.Matrix();
        m.translate(-3.5, -5);
        m.scale(payload.size / 2, new paper.Point(3.5, 5));
        return m;
    })();
    return {
        path: 'M8 5L0.5 9.33013L0.5 0.669873L8 5Z',
        matrix: mapPaperMatrixToModel(payload.matrix.appended(initialMatrix)),
    };
};
const getTriangleFilledHead = (payload) => {
    const initialMatrix = (() => {
        const m = new paper.Matrix();
        m.translate(-3.5, -5);
        m.scale(payload.size / 2, new paper.Point(3.5, 5));
        return m;
    })();
    return {
        path: 'M-5.96244e-08 5L7.5 9.33013L7.5 0.669873L-5.96244e-08 5Z',
        matrix: mapPaperMatrixToModel(payload.matrix.appended(initialMatrix)),
    };
};
const getCircleFilledHead = (payload) => {
    const strokeWeight = payload.size * 3.5;
    const radius = payload.strokeAlign === StrokeAlign.Center ? strokeWeight / 2 : strokeWeight;
    return {
        path: new paper.Path.Circle(new paper.Point(0, 0), radius).pathData,
        matrix: mapPaperMatrixToModel(payload.matrix),
    };
};
const getDiamondFilledHead = (payload) => {
    const initialMatrix = (() => {
        const m = new paper.Matrix();
        m.translate(-payload.size / 2, -payload.size / 2);
        m.rotate(45, new paper.Point(payload.size / 2, payload.size / 2));
        m.scale(3.5, new paper.Point(payload.size / 2, payload.size / 2));
        return m;
    })();
    return {
        path: new paper.Path.Rectangle(new paper.Point(0, 0), new paper.Size(payload.size, payload.size)).pathData,
        matrix: mapPaperMatrixToModel(payload.matrix.appended(initialMatrix)),
    };
};
function mapStrokeCapToGetHead(strokeCap) {
    switch (strokeCap) {
        case StrokeCap.Round:
            return getRoundHead;
        case StrokeCap.Square:
            return getSquareHead;
        case StrokeCap.ArrowLines:
            return getLineArrowHead;
        case StrokeCap.ArrowEquilateral:
            return getTriangleArrowHead;
        case StrokeCap.TriangleFilled:
            return getTriangleFilledHead;
        case StrokeCap.CircleFilled:
            return getCircleFilledHead;
        case StrokeCap.DiamondFilled:
            return getDiamondFilledHead;
        default:
            return null;
    }
}
/**
 * Return abstract arrow heads data for provided path with settings.
 * @param payload.path is svg path. Can be received from current shape by a given time.
 * @param payload.size is related to strokeWeight now but can be adjustable later by custom property.
 */
function getArrowHeadsData(payload, options) {
    const parsedPath = new paper.CompoundPath(payload.path);
    return parsedPath.children.flatMap((providedPath) => {
        const heads = [];
        const p = providedPath;
        const isClosed = p.closed;
        if (isClosed) {
            return heads;
        }
        if (p.curves.length === 0) {
            return heads;
        }
        const startHeadGetter = mapStrokeCapToGetHead(payload.strokeCapStart);
        if (startHeadGetter != null) {
            const startMatrix = (() => {
                const curve = p.firstCurve;
                const matrix = new paper.Matrix();
                if (curve == null) {
                    {
                        const position = p.firstSegment.point;
                        matrix.translate(position.x, position.y);
                    }
                    return matrix;
                }
                {
                    const position = curve.point1;
                    const tangent = curve.getTangentAt(0);
                    matrix.translate(position.x, position.y);
                    matrix.rotate(tangent.angle + 180, new paper.Point(0, 0));
                }
                return matrix;
            })();
            heads.push(startHeadGetter({
                strokeAlign: payload.strokeAlign,
                size: payload.size,
                matrix: startMatrix,
            }));
        }
        const endHeadGetter = mapStrokeCapToGetHead(payload.strokeCapEnd);
        if (endHeadGetter != null) {
            const endMatrix = (() => {
                const curve = p.lastCurve;
                const matrix = new paper.Matrix();
                if (curve == null) {
                    {
                        const position = p.lastSegment.point;
                        matrix.translate(position.x, position.y);
                    }
                    return matrix;
                }
                {
                    const tangent = curve.getTangentAt(curve.length);
                    const position = curve.point2;
                    matrix.translate(position.x, position.y);
                    matrix.rotate(tangent.angle, new paper.Point(0, 0));
                }
                return matrix;
            })();
            heads.push(endHeadGetter({
                strokeAlign: payload.strokeAlign,
                size: payload.size,
                matrix: endMatrix,
            }));
        }
        return heads;
    });
}

function mapModelMatrixToSvg(matrix) {
    return [
        matrix[0][0],
        matrix[0][1],
        matrix[1][0],
        matrix[1][1],
        matrix[0][2],
        matrix[1][2],
    ];
}
const StrokeMeta = ({ node: { size }, stroke, }) => {
    if (stroke.type === 'linear-gradient') {
        // @NOTE: taken from figma
        const startPoint = [0, 0.5];
        const endPoint = [1, 0.5];
        if (stroke.gradientTransform === undefined) {
            throw new Error('invalid state');
        }
        const newStartCoef = getPointCoefficient$2(stroke.gradientTransform, [
            ...startPoint,
            1,
        ]);
        const newEndCoef = getPointCoefficient$2(stroke.gradientTransform, [
            ...endPoint,
            1,
        ]);
        return (React.createElement("defs", null,
            React.createElement("linearGradient", { id: stroke.id, x1: newStartCoef.x * size.x, y1: newStartCoef.y * size.y, x2: newEndCoef.x * size.x, y2: newEndCoef.y * size.y, gradientUnits: "userSpaceOnUse" }, stroke.colorStops.map((colorStop, idx) => (React.createElement("stop", { key: idx, offset: `${colorStop.position * 100}%`, stopOpacity: colorStop.color.a * stroke.opacity, stopColor: `rgb(${colorStop.color.r}, ${colorStop.color.g}, ${colorStop.color.b})` }))))));
    }
    if (stroke.type === 'radial-gradient') {
        // @NOTE: taken from figma
        const startPoint = [0.5, 0.5];
        const endPoint = [1, 0.5];
        if (stroke.gradientTransform === undefined) {
            throw new Error('invalid state');
        }
        const newStartCoef = getPointCoefficient$2(stroke.gradientTransform, [
            ...startPoint,
            1,
        ]);
        const newEndCoef = getPointCoefficient$2(stroke.gradientTransform, [
            ...endPoint,
            1,
        ]);
        const magnitude = Math.sqrt((newEndCoef.x - newStartCoef.x) * (newEndCoef.x - newStartCoef.x) +
            (newEndCoef.y - newStartCoef.y) * (newEndCoef.y - newStartCoef.y));
        return (React.createElement("defs", null,
            React.createElement("radialGradient", { id: stroke.id, fx: newStartCoef.x * size.x, fy: newStartCoef.y * size.y, fr: 0, cx: newStartCoef.x * size.x, cy: newStartCoef.y * size.y, r: magnitude * Math.min(size.x, size.y), gradientUnits: "userSpaceOnUse" }, stroke.colorStops.map((colorStop, idx) => (React.createElement("stop", { key: idx, offset: `${colorStop.position * 100}%`, stopOpacity: colorStop.color.a * stroke.opacity, stopColor: `rgb(${colorStop.color.r}, ${colorStop.color.g}, ${colorStop.color.b})` }))))));
    }
    return null;
};
const StrokeHeads = ({ path, strokeCapStart, strokeCapEnd, size, ...props }) => {
    const heads = getArrowHeadsData({
        strokeAlign: props.strokeAlign,
        strokeCapStart,
        strokeCapEnd,
        path,
        size: props.strokeWeight,
    });
    return (React.createElement(React.Fragment, null, heads.map((head, idx) => (React.createElement("path", { key: idx, d: head.path, transform: `matrix(${mapModelMatrixToSvg(head.matrix).join(',')})`, fill: `rgb(${props.color.r}, ${props.color.g}, ${props.color.b})` })))));
};
const StrokePath = ({ node: { id, dash, gap, dashOffset, strokeCapStart, strokeCapEnd, strokeJoin, size, }, stroke, path, strokeAlign, strokeWeight, }) => {
    const isDefault = strokeCapStart === strokeCapEnd &&
        [StrokeCap.None, StrokeCap.Round, StrokeCap.Square].includes(strokeCapStart);
    const strokeCap = (() => {
        if (!isDefault) {
            return undefined;
        }
        switch (strokeCapStart) {
            case StrokeCap.None:
                return 'butt';
            case StrokeCap.Round:
                return 'round';
            case StrokeCap.Square:
                return 'square';
            default:
                return 'butt';
        }
    })();
    const heads = !isDefault && stroke.type === 'solid' ? (React.createElement(StrokeHeads, { strokeAlign: strokeAlign, strokeWeight: strokeWeight, color: stroke.color, path: path, strokeCapStart: strokeCapStart, strokeCapEnd: strokeCapEnd, size: size })) : (React.createElement(React.Fragment, null,
        React.createElement("defs", null,
            React.createElement("mask", { id: `${safeString$1(id)}_gradient_mask` },
                React.createElement(StrokeHeads, { strokeAlign: strokeAlign, strokeWeight: strokeWeight, color: {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1,
                    }, path: path, strokeCapStart: strokeCapStart, strokeCapEnd: strokeCapEnd, size: size }))),
        React.createElement("rect", { x: -(size.x + strokeWeight * 2), y: -(size.y + strokeWeight * 2), width: (size.x + strokeWeight * 2) * 3, height: (size.y + strokeWeight * 2) * 3, fill: `url(#${stroke.id})`, mask: `url(#${safeString$1(id)}_gradient_mask)` })));
    return (React.createElement("g", { clipPath: strokeAlign === StrokeAlign.Center
            ? undefined
            : `url(#${safeString$1(id)}_stroke_clip_path)` },
        React.createElement("path", { id: `${safeString$1(id)}_stroke_path`, d: path, fill: "none", stroke: stroke.type === 'solid'
                ? `rgb(${stroke.color.r}, ${stroke.color.g}, ${stroke.color.b})`
                : `url(#${stroke.id})`, strokeWidth: strokeAlign === StrokeAlign.Center ? strokeWeight : strokeWeight * 2, strokeLinecap: strokeCap, 
            // @ts-ignore
            strokeLinejoin: strokeJoin.toLowerCase(), 
            // @NOTE: not include dasharray and dashoffset if it doesn't exists.
            // Affect on performance in safari.
            strokeDasharray: dash !== 0 && gap === 0 ? undefined : [dash, gap].join(' '), strokeDashoffset: dashOffset === 0 ? undefined : dashOffset, strokeOpacity: stroke.type === 'solid' ? stroke.color.a : undefined }),
        heads));
};
const IndividualStrokes = ({ node, strokeAlign }) => (React.createElement(React.Fragment, null, node.strokes.map((stroke, idx) => {
    if (stroke.type === 'image') {
        const internalStroke = {
            type: 'solid',
            color: { r: 255, g: 255, b: 255, a: 1 },
        };
        if (node.individualStrokesData === undefined) {
            throw new Error('invalid state');
        }
        return (React.createElement("g", { key: idx, style: {
                // @ts-ignore
                mixBlendMode: stroke.blendMode,
            } },
            React.createElement("defs", null,
                React.createElement("mask", { id: `${safeString$1(node.id)}_${stroke.id}_image` },
                    node.strokeTopWeight !== 0 && (React.createElement(StrokePath, { node: node, 
                        // @ts-ignore
                        stroke: internalStroke, strokeWeight: node.strokeTopWeight, path: node.individualStrokesData.top.data, strokeAlign: strokeAlign })),
                    node.strokeRightWeight !== 0 && (React.createElement(StrokePath, { node: node, 
                        // @ts-ignore
                        stroke: internalStroke, strokeWeight: node.strokeRightWeight, path: node.individualStrokesData.right.data, strokeAlign: strokeAlign })),
                    node.strokeBottomWeight !== 0 && (React.createElement(StrokePath, { node: node, 
                        // @ts-ignore
                        stroke: internalStroke, strokeWeight: node.strokeBottomWeight, path: node.individualStrokesData.bottom.data, strokeAlign: strokeAlign })),
                    node.strokeLeftWeight !== 0 && (React.createElement(StrokePath, { node: node, 
                        // @ts-ignore
                        stroke: internalStroke, strokeWeight: node.strokeLeftWeight, path: node.individualStrokesData.left.data, strokeAlign: strokeAlign })))),
            React.createElement(Image$1, { ...stroke, size: node.size, pathId: `${safeString$1(node.id)}_${stroke.id}_image`, pathType: "mask" })));
    }
    if (node.individualStrokesData === undefined) {
        throw new Error('invalid state');
    }
    return (React.createElement("g", { key: idx, style: {
            // @ts-ignore
            mixBlendMode: stroke.blendMode,
        } },
        React.createElement(StrokeMeta, { node: node, stroke: stroke }),
        node.strokeTopWeight !== 0 && (React.createElement(StrokePath, { node: node, stroke: stroke, strokeWeight: node.strokeTopWeight, path: node.individualStrokesData.top.data, strokeAlign: strokeAlign })),
        node.strokeRightWeight !== 0 && (React.createElement(StrokePath, { node: node, stroke: stroke, strokeWeight: node.strokeRightWeight, path: node.individualStrokesData.right.data, strokeAlign: strokeAlign })),
        node.strokeBottomWeight !== 0 && (React.createElement(StrokePath, { node: node, stroke: stroke, strokeWeight: node.strokeBottomWeight, path: node.individualStrokesData.bottom.data, strokeAlign: strokeAlign })),
        node.strokeLeftWeight !== 0 && (React.createElement(StrokePath, { node: node, stroke: stroke, strokeWeight: node.strokeLeftWeight, path: node.individualStrokesData.left.data, strokeAlign: strokeAlign }))));
})));
const CommonStrokes = ({ node, strokeAlign }) => (React.createElement(React.Fragment, null, node.strokes.map((stroke, idx) => {
    if (stroke.type === 'image' && stroke.image != null) {
        return (React.createElement("g", { key: idx, style: {
                // @ts-ignore
                mixBlendMode: stroke.blendMode,
            } },
            React.createElement("defs", null,
                React.createElement("mask", { id: `${safeString$1(node.id)}_${stroke.id}_image` },
                    React.createElement(StrokePath, { node: node, 
                        // @ts-ignore
                        stroke: {
                            type: 'solid',
                            color: {
                                r: 255,
                                g: 255,
                                b: 255,
                                a: 1,
                            },
                        }, strokeWeight: node.strokeWeight, path: node.data.map((p) => p.data).join(' '), strokeAlign: strokeAlign }))),
            React.createElement(Image$1, { ...stroke, size: node.size, pathId: `${safeString$1(node.id)}_${stroke.id}_image`, pathType: "mask" })));
    }
    return (React.createElement("g", { key: idx, style: {
            // @ts-ignore
            mixBlendMode: stroke.blendMode,
        } },
        React.createElement(StrokeMeta, { node: node, stroke: stroke }),
        React.createElement(StrokePath, { node: node, stroke: stroke, strokeWeight: node.strokeWeight, path: node.data.map((p) => p.data).join(' '), strokeAlign: strokeAlign })));
})));
const Strokes = ({ node }) => {
    const { id, size, fillData, strokes, strokeWeight, strokeTopWeight, strokeRightWeight, strokeBottomWeight, strokeLeftWeight, strokeAlign: providedStrokeAlign, individualStrokesEnabled, } = node;
    const maxStrokeWeight = [
        strokeWeight,
        strokeTopWeight,
        strokeRightWeight,
        strokeBottomWeight,
        strokeLeftWeight,
    ].reduce((acc, weight) => Math.max(acc, weight), Number.NEGATIVE_INFINITY);
    if (strokes.filter((stroke) => stroke.visible).length === 0) {
        return null;
    }
    // @NOTE: temporary disabled because it broke trim path animation inside of animated svg.
    // if (
    //   (individualStrokesEnabled &&
    //     strokeTopWeight === 0 &&
    //     strokeRightWeight === 0 &&
    //     strokeBottomWeight === 0 &&
    //     strokeLeftWeight === 0) ||
    //   (individualStrokesEnabled === false && strokeWeight === 0)
    // ) {
    //   return null
    // }
    const rawFillPath = fillData.map((vectorPath) => vectorPath.data).join('');
    const clipRectData = `M${-maxStrokeWeight},${-maxStrokeWeight} H${size.x + maxStrokeWeight} V${size.y + maxStrokeWeight} H${-maxStrokeWeight} Z`;
    const strokeAlign = rawFillPath.toLowerCase().includes('z') === false
        ? StrokeAlign.Center
        : providedStrokeAlign;
    return (React.createElement(React.Fragment, null,
        strokeAlign !== StrokeAlign.Center && (React.createElement("defs", null,
            React.createElement("clipPath", { id: `${safeString$1(id)}_stroke_clip_path`, clipPathUnits: "userSpaceOnUse" },
                strokeAlign === StrokeAlign.Inside && (React.createElement("path", { id: `${safeString$1(id)}_stroke_path`, d: rawFillPath })),
                strokeAlign === StrokeAlign.Outside && (React.createElement("path", { id: `${safeString$1(id)}_stroke_path`, d: `${clipRectData} ${rawFillPath}`, clipRule: "evenodd" }))))),
        individualStrokesEnabled ? (React.createElement(IndividualStrokes, { node: node, strokeAlign: strokeAlign })) : (React.createElement(CommonStrokes, { node: node, strokeAlign: strokeAlign }))));
};
Strokes.displayName = 'Strokes';

const OFFSET_IN_PERCENTS$1 = 0.2;
const InnerShadows = ({ node, shadows }) => {
    if (node == null) {
        return null;
    }
    const expansionPercentage = Math.max(...shadows.map((s) => s.radius)) /
        Math.min(node.size.x, node.size.y) +
        OFFSET_IN_PERCENTS$1;
    const xOffset = Math.max(...shadows.map((s) => s.offset.x)) / node.size.x -
        expansionPercentage;
    const yOffset = Math.max(...shadows.map((s) => s.offset.y)) / node.size.y -
        expansionPercentage;
    return (React.createElement(React.Fragment, null,
        React.createElement("defs", null,
            React.createElement("filter", { id: shadows[0].id, x: `${xOffset * 100}%`, y: `${yOffset * 100}%`, width: `${(expansionPercentage * 2 + 1) * 100}%`, height: `${(expansionPercentage * 2 + 1) * 100}%`, filterUnits: "objectBoundingBox" },
                React.createElement(React.Fragment, null,
                    shadows.map((shadow) => (React.createElement(React.Fragment, { key: shadow.id },
                        React.createElement("feOffset", { dx: shadow.offset.x, dy: shadow.offset.y, in: "SourceGraphic", result: `${shadow.id}_offset` }),
                        React.createElement("feGaussianBlur", { stdDeviation: shadow.radius / 2, in: `${shadow.id}_offset`, result: `${shadow.id}_offset_blur` }),
                        React.createElement("feComposite", { operator: "out", in: "SourceGraphic", in2: `${shadow.id}_offset_blur`, result: `${shadow.id}_inverse` }),
                        React.createElement("feFlood", { floodColor: `rgb(${shadow.color.r} ${shadow.color.g} ${shadow.color.b})`, floodOpacity: shadow.color.a, in: `${shadow.id}_inverse`, result: `${shadow.id}_color` }),
                        React.createElement("feComposite", { operator: "in", in: `${shadow.id}_color`, in2: `${shadow.id}_inverse`, result: `${shadow.id}_shadow_result` })))),
                    React.createElement("feMerge", null,
                        React.createElement("feMergeNode", { in: "SourceGraphic" }),
                        shadows.map((shadow) => (React.createElement("feMergeNode", { key: shadow.id, in: `${shadow.id}_shadow_result` })))))))));
};
InnerShadows.displayName = 'InnerShadows';

const OFFSET_IN_PERCENTS = 0.2;
const LayerBlur = ({ node, blurs, children, }) => {
    if (node == null ||
        blurs == null ||
        blurs.filter((blur) => blur.visible).length === 0) {
        return React.createElement(React.Fragment, null, children);
    }
    const expansionPercentage = Math.max(...node.layerBlurs.map((s) => s.radius)) /
        Math.min(node.size.x, node.size.y) +
        OFFSET_IN_PERCENTS;
    return (React.createElement(React.Fragment, null,
        React.createElement("defs", null,
            React.createElement("filter", { id: blurs[0].id, x: `-${expansionPercentage * 100}%`, y: `-${expansionPercentage * 100}%`, width: `${(expansionPercentage * 2 + 1) * 100}%`, height: `${(expansionPercentage * 2 + 1) * 100}%`, filterRes: 0.5, filterUnits: "objectBoundingBox" },
                React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix" }),
                React.createElement("feGaussianBlur", { id: `${blurs[0].id}_radius`, key: blurs[0].id, 
                    // @NOTE: because figma divide it by coefficient
                    stdDeviation: blurs[0].radius / 2 }))),
        React.createElement("g", { filter: `url(#${blurs[0].id})` }, children)));
};
LayerBlur.displayName = 'LayerBlur';

const SvgLayerBlend = ({ node, children }) => (React.createElement("g", { id: safeString$1(node.id), opacity: node.opacity, style: {
        // @ts-ignore
        mixBlendMode: node?.blendMode ?? 'normal',
    } }, children));
SvgLayerBlend.displayName = 'SvgLayerBlend';

const TextLayerFills = ({ node }) => {
    const { size, entity } = node;
    const styledSegments = entity
        .getAspect(StyledTextSegmentRelationsAspect)
        ?.getChildrenList();
    if (!styledSegments || styledSegments.length === 0)
        return null;
    const paragraphMeta = {
        alignHorizontal: entity.getComponentOrThrow(TextAlignHorizontalComponent)
            .value,
        alignVertical: entity.getComponentOrThrow(TextAlignVerticalComponent).value,
        autoResize: entity.getComponentOrThrow(TextAutoResizeComponent).value,
        truncation: entity.getComponentOrThrow(TextTruncationComponent).value,
    };
    const paragraphStyle = {
        margin: 'auto',
        width: `${size.x}px`,
        textAlign: mapHorizontalAlign(paragraphMeta.alignHorizontal),
        verticalAlign: mapVerticalAlign(paragraphMeta.alignVertical),
        whiteSpace: paragraphMeta.autoResize ? 'normal' : 'nowrap',
        overflow: paragraphMeta.truncation ? 'hidden' : 'visible',
        textOverflow: paragraphMeta.truncation ? 'ellipsis' : 'clip',
        dominantBaseline: 'hanging',
        textRendering: 'geometricPrecision',
    };
    return (React.createElement("g", { width: size.x, height: size.y }, node.lines.map((line, lineIdx) => (React.createElement(React.Fragment, { key: lineIdx }, styledSegments.map((segment, segmentIndex) => {
        const segmentFills = node.styledSegmentsFills[segmentIndex];
        const segmentMeta = extractSegmentMeta(segment);
        const segmentStyle = createTextStyle(segmentMeta, node);
        const startIndex = segmentMeta.startIndex;
        const endIndex = segmentMeta.endIndex;
        if (startIndex <= line.endIndex && endIndex >= line.startIndex) {
            const segmentStartInLine = Math.max(startIndex, line.startIndex) - line.startIndex;
            const segmentEndInLine = Math.min(endIndex, line.endIndex) - line.startIndex;
            const textInLine = line.text.slice(segmentStartInLine, segmentEndInLine);
            return segmentFills.map((fill, fillIndex) => {
                const fillId = `${safeString$1(node.id)}_${segmentIndex}_${fillIndex}`;
                const baseTextProps = {
                    key: `${lineIdx}-${segmentIndex}-${fillIndex}`,
                    x: line.rect.x,
                    y: line.rect.y +
                        extractSegmentMeta(styledSegments[0]).fontSize * 0.2,
                    style: {
                        ...segmentStyle,
                        ...paragraphStyle,
                        mixBlendMode: fill.blendMode,
                    },
                };
                if (fill.type === 'solid') {
                    return (React.createElement("text", { ...baseTextProps, style: {
                            ...baseTextProps.style,
                            fill: `rgba(${fill.color.r}, ${fill.color.g}, ${fill.color.b}, ${fill.color.a})`,
                        } }, textInLine));
                }
                if (fill.type === 'linear-gradient' ||
                    fill.type === 'radial-gradient') {
                    const isLinear = fill.type === 'linear-gradient';
                    const GradientElement = isLinear
                        ? 'linearGradient'
                        : 'radialGradient';
                    const gradientProps = isLinear
                        ? { x1: '0', y1: '0.5', x2: '1', y2: '0.5' }
                        : { cx: '0.5', cy: '0.5', r: '0.5' };
                    return (React.createElement(React.Fragment, { key: baseTextProps.key },
                        React.createElement("defs", null,
                            React.createElement(GradientElement, { id: fillId, ...gradientProps, gradientTransform: svgMatrix(inverted6x1Matrix(map3x2to6x1Matrix(fill.gradientTransform))), gradientUnits: "objectBoundingBox" }, fill.colorStops.map((colorStop, stopIndex) => (React.createElement("stop", { key: stopIndex, offset: `${colorStop.position * 100}%`, stopOpacity: colorStop.color.a * (fill.opacity ?? 1), stopColor: `rgb(${colorStop.color.r}, ${colorStop.color.g}, ${colorStop.color.b})` }))))),
                        React.createElement("text", { ...baseTextProps, style: {
                                ...baseTextProps.style,
                                fill: `url(#${fillId})`,
                            } }, textInLine)));
                }
                if (fill.type === 'image' && fill.image?.loaded) {
                    const clipPathId = `${fillId}_clip_path`;
                    return (React.createElement(React.Fragment, { key: baseTextProps.key },
                        React.createElement("defs", null,
                            React.createElement("clipPath", { id: clipPathId },
                                React.createElement("text", { ...baseTextProps }, textInLine))),
                        React.createElement("g", { style: {
                                mixBlendMode: fill.blendMode,
                            } },
                            React.createElement(Image$1, { image: fill.image, size: size, opacity: fill.opacity, scaleMode: fill.scaleMode, imageTransform: fill.imageTransform, scalingFactor: fill.scalingFactor, rotation: fill.rotation, pathId: clipPathId }))));
                }
                return (React.createElement("text", { ...baseTextProps, key: baseTextProps.key }, textInLine));
            });
        }
        return null;
    }))))));
};
TextLayerFills.displayName = 'TextLayerFills';

const TextLayerStrokes = ({ node }) => {
    const { size, entity } = node;
    const styledSegments = entity
        .getAspect(StyledTextSegmentRelationsAspect)
        ?.getChildrenList();
    if (!styledSegments || styledSegments.length === 0)
        return null;
    const paragraphMeta = {
        alignHorizontal: entity.getComponentOrThrow(TextAlignHorizontalComponent)
            .value,
        alignVertical: entity.getComponentOrThrow(TextAlignVerticalComponent).value,
        autoResize: entity.getComponentOrThrow(TextAutoResizeComponent).value,
        truncation: entity.getComponentOrThrow(TextTruncationComponent).value,
    };
    const paragraphStyle = {
        margin: 'auto',
        width: `${size.x}px`,
        textAlign: mapHorizontalAlign(paragraphMeta.alignHorizontal),
        verticalAlign: mapVerticalAlign(paragraphMeta.alignVertical),
        whiteSpace: paragraphMeta.autoResize ? 'normal' : 'nowrap',
        overflow: paragraphMeta.truncation ? 'hidden' : 'visible',
        textOverflow: paragraphMeta.truncation ? 'ellipsis' : 'clip',
        dominantBaseline: 'hanging',
        textRendering: 'geometricPrecision',
        fill: 'none',
    };
    return (React.createElement(React.Fragment, null,
        node.strokes.map((stroke, strokeIndex) => (React.createElement("defs", { key: `defs-${strokeIndex}` }, node.lines.map((line, lineIndex) => (React.createElement("clipPath", { key: `line-${lineIndex}`, id: `${safeString$1(node.id)}_stroke_${strokeIndex}_line_${lineIndex}_clip_path`, clipPathUnits: "userSpaceOnUse" },
            React.createElement("text", { x: line.rect.x, y: line.rect.y +
                    extractSegmentMeta(styledSegments[0]).fontSize * 0.2, style: paragraphStyle, textRendering: "geometricPrecision" }, styledSegments.map((segment, segmentIndex) => {
                const segmentMeta = extractSegmentMeta(segment);
                const segmentStyle = createTextStyle(segmentMeta, node);
                const startIndex = segmentMeta.startIndex;
                const endIndex = segmentMeta.endIndex;
                if (startIndex <= line.endIndex &&
                    endIndex >= line.startIndex) {
                    const segmentStartInLine = Math.max(startIndex, line.startIndex) - line.startIndex;
                    const segmentEndInLine = Math.min(endIndex, line.endIndex) - line.startIndex;
                    const textInLine = line.text.slice(segmentStartInLine, segmentEndInLine);
                    return (React.createElement("tspan", { key: segmentIndex, style: segmentStyle, dx: segmentIndex === 0 ? 0 : undefined }, textInLine));
                }
                return null;
            })))))))),
        React.createElement("g", { width: size.x, height: size.y }, node.lines.map((line, lineIndex) => (React.createElement("text", { key: lineIndex, x: line.rect.x, y: line.rect.y + extractSegmentMeta(styledSegments[0]).fontSize * 0.2, style: paragraphStyle, textRendering: "geometricPrecision" }, styledSegments.map((segment, segmentIndex) => {
            const segmentStrokes = node.strokes;
            const segmentMeta = extractSegmentMeta(segment);
            const segmentStyle = createTextStyle(segmentMeta, node);
            const startIndex = segmentMeta.startIndex;
            const endIndex = segmentMeta.endIndex;
            if (startIndex <= line.endIndex && endIndex >= line.startIndex) {
                const segmentStartInLine = Math.max(startIndex, line.startIndex) - line.startIndex;
                const segmentEndInLine = Math.min(endIndex, line.endIndex) - line.startIndex;
                const textInLine = line.text.slice(segmentStartInLine, segmentEndInLine);
                return segmentStrokes.map((stroke, strokeIndex) => {
                    const strokeId = `${safeString$1(node.id)}_${segmentIndex}_${strokeIndex}_stroke`;
                    if (stroke.type === 'solid') {
                        return (React.createElement("tspan", { key: `${segmentIndex}-${strokeIndex}`, style: {
                                ...segmentStyle,
                                stroke: `rgba(${stroke.color.r}, ${stroke.color.g}, ${stroke.color.b}, ${stroke.color.a})`,
                                strokeWidth: node.strokeAlign === StrokeAlign$1.Outside
                                    ? node.strokeWeight
                                    : node.strokeAlign === StrokeAlign$1.Center
                                        ? node.strokeWeight * 1.5
                                        : node.strokeWeight * 2,
                                mixBlendMode: stroke.blendMode,
                            }, dx: segmentIndex === 0 && strokeIndex === 0
                                ? 0
                                : undefined, clipPath: node.strokeAlign !== StrokeAlign$1.Outside
                                ? `url(#${safeString$1(node.id)}_stroke_${strokeIndex}_line_${lineIndex}_clip_path)`
                                : undefined }, textInLine));
                    }
                    if (stroke.type === 'linear-gradient' ||
                        stroke.type === 'radial-gradient') {
                        const isLinear = stroke.type === 'linear-gradient';
                        const GradientElement = isLinear
                            ? 'linearGradient'
                            : 'radialGradient';
                        const startPoint = [0, 0.5];
                        const endPoint = [1, 0.5];
                        const newStartCoef = getPointCoefficient$2(stroke.gradientTransform, [...startPoint, 1]);
                        const newEndCoef = getPointCoefficient$2(stroke.gradientTransform, [...endPoint, 1]);
                        const gradientProps = isLinear
                            ? {
                                x1: newStartCoef.x * size.x,
                                y1: newStartCoef.y * size.y,
                                x2: newEndCoef.x * size.x,
                                y2: newEndCoef.y * size.y,
                            }
                            : { cx: '0.5', cy: '0.5', r: '0.5' };
                        return (React.createElement(React.Fragment, { key: `${segmentIndex}-${strokeIndex}` },
                            React.createElement("defs", null,
                                React.createElement(GradientElement, { id: strokeId, ...gradientProps, gradientUnits: "objectBoundingBox" }, stroke.colorStops.map((colorStop, stopIndex) => (React.createElement("stop", { key: stopIndex, offset: `${colorStop.position * 100}%`, stopOpacity: colorStop.color.a * stroke.opacity, stopColor: `rgb(${colorStop.color.r}, ${colorStop.color.g}, ${colorStop.color.b})` }))))),
                            React.createElement("tspan", { style: {
                                    ...segmentStyle,
                                    stroke: `url(#${stroke.id})`,
                                    strokeWidth: node.strokeAlign === StrokeAlign$1.Outside
                                        ? node.strokeWeight
                                        : node.strokeAlign === StrokeAlign$1.Center
                                            ? node.strokeWeight * 1.5
                                            : node.strokeWeight * 2,
                                    mixBlendMode: stroke.blendMode,
                                }, dx: segmentIndex === 0 && strokeIndex === 0
                                    ? 0
                                    : undefined, clipPath: node.strokeAlign !== StrokeAlign$1.Outside
                                    ? `url(#${safeString$1(node.id)}_stroke_${strokeIndex}_line_${lineIndex}_clip_path)`
                                    : undefined }, textInLine)));
                    }
                    return null;
                });
            }
            return null;
        })))))));
};
TextLayerStrokes.displayName = 'TextLayerStrokes';

const SvgLayerContent = ({ snapshot, renderText, children }) => {
    if (snapshot == null || snapshot.visible === false) {
        return null;
    }
    if (snapshot.data.length === 0) {
        return null;
    }
    const safeNodeId = safeString$1(snapshot.id);
    return (React.createElement("g", null,
        snapshot.clipContent && (React.createElement("defs", null,
            React.createElement("clipPath", { id: `${safeNodeId}_clipPath`, x: "-50%", y: "-50%", width: "200%", height: "200%" }, snapshot.data.map((vectorPath, idx) => (React.createElement("path", { id: `${safeNodeId}_fill_path`, key: idx, d: vectorPath.data, fill: "white", clipRule: mapWindingRule(vectorPath.windingRule) })))))),
        React.createElement("g", { clipPath: snapshot.clipContent ? `url(#${safeNodeId}_clipPath)` : undefined }, snapshot.type === NodeType$1.Text && renderText ? (React.createElement(React.Fragment, null,
            React.createElement(TextLayerFills, { node: snapshot }),
            React.createElement(TextLayerStrokes, { node: snapshot }))) : (React.createElement(React.Fragment, null,
            React.createElement(Fills, { node: snapshot }),
            snapshot.clipContent && children,
            snapshot.clipContent === false && React.createElement(Strokes, { node: snapshot }),
            snapshot.clipContent === false && children))),
        snapshot.clipContent && React.createElement(Strokes, { node: snapshot })));
};
SvgLayerContent.displayName = 'SvgLayerContent';

const WithDropShadows = ({ node, children, }) => {
    if (node.dropShadows.length > 0) {
        return (React.createElement(React.Fragment, null,
            React.createElement(DropShadows, { node: node, shadows: node.dropShadows }),
            React.createElement("g", { filter: `url(#${node.dropShadows[0].id})` }, children)));
    }
    return React.createElement(React.Fragment, null, children);
};
const WithInnerShadows = ({ node, children, }) => {
    if (node.innerShadows.length > 0) {
        return (React.createElement(React.Fragment, null,
            React.createElement(InnerShadows, { node: node, shadows: node.innerShadows }),
            React.createElement("g", { filter: `url(#${node.innerShadows[0].id})` }, children)));
    }
    return React.createElement(React.Fragment, null, children);
};
const SvgLayerTransform = ({ node, children }) => {
    return (React.createElement(WithDropShadows, { node: node },
        React.createElement(WithInnerShadows, { node: node },
            React.createElement("g", { id: `${safeString$1(node.id)}_translate` },
                React.createElement("g", { transform: `matrix(${node.transformMatrix.values})` }, children)))));
};
SvgLayerTransform.displayName = 'SvgLayerTransform';

const noop$2 = () => true;
// function isVisibleInParent(
//   snapshot: NodeSnapshot,
//   parent: NodeSnapshot
// ): boolean {
//   if (snapshot.opacity === 0) {
//     return false
//   }
//   if (parent.opacity === 0) {
//     return false
//   }
//   if (parent.clipContent === false) {
//     return true
//   }
//   const rootFrameRect = new paper.Path.Rectangle(
//     new paper.Rectangle(
//       new paper.Point(0, 0),
//       new paper.Point(parent.size.x, parent.size.y)
//     )
//   )
//   const currentNodeRect = new paper.Path.Rectangle(
//     new paper.Rectangle(
//       new paper.Point(0, 0),
//       new paper.Point(
//         snapshot.size.x * snapshot.scale.x,
//         snapshot.size.y * snapshot.scale.y
//       )
//     )
//   )
//   currentNodeRect.transform(snapshot.absoluteTransformMatrix)
//   return (
//     rootFrameRect.intersects(currentNodeRect) ||
//     // @NOTE: in case root bigger than current layer
//     rootFrameRect.contains(currentNodeRect.bounds.topLeft) ||
//     rootFrameRect.contains(currentNodeRect.bounds.bottomRight) ||
//     // @NOTE: in case current layer bigger than root
//     currentNodeRect.contains(rootFrameRect.bounds.topLeft) ||
//     currentNodeRect.contains(rootFrameRect.bounds.bottomRight)
//   )
// }
/**
 * Check if layer currently visible in viewport. Required for optimizations.
 */
function isVisibleInViewport$2(snapshot, rootSnapshot) {
    // @NOTE: faster to return layer instead of checking the whole hierarchy
    return true;
    // @TODO: add check for the whole chain of frames here
    // return isVisibleInParent(snapshot, rootSnapshot)
}
/**
 * - Use this component in `<svg>` context.
 * - Unless you have full screen viewbox as in viewport, you will have to make svg's viewbox match root node size.
 * - If you want to use autoresized svg, use `<Viewbox/>` component
 *
 * @see {@link Viewbox}
 *
 * @example
 * <svg>
 *  <SvgLayer {...props}/>
 * </svg>
 */
const SvgLayerOrigin$2 = ({ rootSnapshot, snapshot, shouldRender = noop$2, ignoreViewportVisibility = false, renderText = false, }) => {
    const shouldRenderFilter = (n) => {
        const isBelow = n.backgroundBlurs.length === 0 && n.zIndex < snapshot.zIndex;
        if (isBelow === false) {
            return false;
        }
        const providedBoundingBox = new paper.Path.Rectangle(new paper.Rectangle(new paper.Point(0, 0), new paper.Size(n.size.x, n.size.y)));
        providedBoundingBox.transform(n.absoluteTransformMatrix);
        const currentBoundingBox = new paper.Path.Rectangle(new paper.Rectangle(new paper.Point(0, 0), new paper.Size(snapshot.size.x, snapshot.size.y)));
        currentBoundingBox.transform(snapshot.absoluteTransformMatrix);
        const isIntersected = providedBoundingBox.intersects(providedBoundingBox);
        const isContain = providedBoundingBox.contains(providedBoundingBox.bounds.center);
        return isIntersected || isContain;
    };
    if (snapshot == null || snapshot.visible === false) {
        return null;
    }
    if (shouldRender(snapshot) === false) {
        return null;
    }
    if (ignoreViewportVisibility === false &&
        isVisibleInViewport$2() === false) {
        return null;
    }
    // @NOTE: disabled because it's caused performance degradation on each render.
    // @TODO: move to snapshot to `.visible` property.
    // @NOTE: disabled layer display when it has odd matrix values.
    // Usually caused by skew parameter.
    // if (
    //   snapshot.transformMatrix.values.some((number) => Math.abs(number) > 10000)
    // ) {
    //   return null
    // }
    if (snapshot.layerBlurs.length > 0) {
        return (React.createElement(SvgLayerTransform, { node: snapshot },
            React.createElement(SvgLayerBlend, { node: snapshot },
                React.createElement(LayerBlur, { node: snapshot, blurs: snapshot.layerBlurs },
                    React.createElement(SvgLayerContent, { renderText: renderText, snapshot: snapshot }, snapshot.children.map((child) => (React.createElement(SvgLayerOrigin$2, { renderText: renderText, key: `${snapshot.name}-${snapshot.id}/${child.name}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility }))))))));
    }
    if (snapshot.backgroundBlurs.length > 0 && shouldRender === noop$2) {
        return (React.createElement(SvgLayerTransform, { node: snapshot },
            React.createElement(BackgroundBlur, { node: snapshot, blurs: snapshot.backgroundBlurs, BlurContent: React.createElement(SvgLayerOrigin$2, { renderText: renderText, rootSnapshot: rootSnapshot, snapshot: rootSnapshot, shouldRender: shouldRenderFilter, ignoreViewportVisibility: ignoreViewportVisibility }) },
                React.createElement(SvgLayerBlend, { node: snapshot },
                    React.createElement(SvgLayerContent, { snapshot: snapshot, renderText: renderText }, snapshot.children.map((child) => (React.createElement(SvgLayerOrigin$2, { renderText: renderText, key: `${snapshot.name}-${snapshot.id}/${child.name}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility }))))))));
    }
    if (snapshot.hasMasks) {
        // @NOTE: MASK
        const childrenGroupsByMasks = [[]];
        let maskIdx = 0;
        const childrenCount = snapshot.children.length;
        for (let i = 0; i < childrenCount; i += 1) {
            const child = snapshot.children[i];
            if (child.isMask) {
                maskIdx = i;
            }
            childrenGroupsByMasks.push([]);
            childrenGroupsByMasks[maskIdx].push(child);
        }
        const layers = childrenGroupsByMasks
            .filter((childrenGroupByMasks) => childrenGroupByMasks.length !== 0)
            .map((childrenGroupByMasks) => {
            const mask = R.head(childrenGroupByMasks);
            const isMaskEnabled = mask.visible && mask.isMask;
            const maskId = `${safeString$1(mask.id)}_mask`;
            if (isMaskEnabled) {
                return (React.createElement(React.Fragment, { key: childrenGroupByMasks.map((child) => child.id).join('-') },
                    React.createElement("defs", null,
                        React.createElement("mask", { id: maskId, style: {
                                maskType: 'alpha',
                            }, x: "-50%", y: "-50%", width: "200%", height: "200%" },
                            React.createElement(SvgLayerOrigin$2, { renderText: renderText, rootSnapshot: rootSnapshot, snapshot: mask, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility }))),
                    React.createElement("g", { mask: `url(#${maskId})` }, R.drop(1, childrenGroupByMasks).map((child) => (React.createElement(SvgLayerOrigin$2, { renderText: renderText, key: `${maskId}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility }))))));
            }
            return (React.createElement(React.Fragment, { key: childrenGroupByMasks.map((child) => child.id).join('-') }, childrenGroupByMasks.map((child) => (React.createElement(SvgLayerOrigin$2, { renderText: renderText, key: `${snapshot.name}-${snapshot.id}/${child.name}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility })))));
        });
        return (React.createElement(SvgLayerTransform, { node: snapshot },
            React.createElement(SvgLayerBlend, { node: snapshot },
                React.createElement(SvgLayerContent, { renderText: renderText, snapshot: snapshot }, layers))));
    }
    return (React.createElement(SvgLayerTransform, { node: snapshot },
        React.createElement(SvgLayerBlend, { node: snapshot },
            React.createElement(SvgLayerContent, { renderText: renderText, snapshot: snapshot }, snapshot.children.map((child) => (React.createElement(SvgLayerOrigin$2, { renderText: renderText, key: `${snapshot.name}-${snapshot.id}/${child.name}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility })))))));
};
const SvgLayer = ({ snapshot, rootSnapshot, shouldRender, ignoreViewportVisibility, renderText = false, }) => {
    return (React.createElement(SvgLayerOrigin$2, { renderText: renderText, snapshot: snapshot, rootSnapshot: rootSnapshot, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility }));
};

const ProjectPlaybackContext = createContext(undefined);
const ProjectPlaybackProvider = React__default.memo(({ project, children, imageStore }) => {
    return (React__default.createElement(ProjectPlaybackContext.Provider, { value: { project, imageStore } }, children));
}, (prev, next) => prev.project !== next.project || prev.imageStore !== next.imageStore);
const useProjectPlaybackTime = () => {
    const context = useContext(ProjectPlaybackContext);
    if (context === undefined) {
        throw new Error('usePlaybackTime must be used within a PlaybackProvider');
    }
    return context;
};

function extractLines(paragraphNode) {
    if (!(paragraphNode instanceof HTMLParagraphElement)) {
        throw new Error('Lines can only be extracted from paragraph nodes.');
    }
    const range = document.createRange();
    const lineMap = new Map();
    const paragraphRect = paragraphNode.getBoundingClientRect();
    let totalCharCount = 0;
    // Function to process text nodes
    const processTextNode = (textNode) => {
        const textContent = textNode.textContent || '';
        for (let i = 0; i < textContent.length; i++) {
            range.setStart(textNode, i);
            range.setEnd(textNode, i + 1);
            const clientRect = range.getBoundingClientRect();
            const lineY = Math.round(clientRect.top - paragraphRect.top);
            const parentId = textNode.parentElement?.id ?? '';
            if (!lineMap.has(`${lineY}-${parentId}`)) {
                if (textContent.charAt(i).match(/\s/)) {
                    continue;
                }
                // New line detected
                lineMap.set(`${lineY}-${parentId}`, {
                    text: textContent.charAt(i),
                    rect: {
                        x: clientRect.left - paragraphRect.left,
                        y: lineY,
                        width: clientRect.width,
                        height: clientRect.height,
                    },
                    startIndex: totalCharCount + i,
                    endIndex: totalCharCount + i + 1,
                });
            }
            else {
                // Append to existing line
                const currentLine = lineMap.get(`${lineY}-${parentId}`);
                currentLine.text += textContent.charAt(i);
                currentLine.endIndex = totalCharCount + i + 1;
                currentLine.rect.width =
                    clientRect.right - paragraphRect.left - currentLine.rect.x;
            }
        }
        totalCharCount += textContent.length;
    };
    // Recursive function to process nodes
    const processNode = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
            processTextNode(node);
        }
        else if (node.nodeType === Node.ELEMENT_NODE) {
            for (const childNode of node.childNodes) {
                processNode(childNode);
            }
        }
    };
    // Process all child nodes of the paragraph
    processNode(paragraphNode);
    // Convert the map to an array and sort by y-position
    const lines = Array.from(lineMap.values()).sort((a, b) => a.rect.y - b.rect.y);
    return lines;
}

function lerp(t, min, max) {
    return min + (max - min) * t;
}
function lerpRange(value, minValue, maxValue, min, max) {
    if (maxValue === minValue || value === minValue) {
        return min;
    }
    const t = (value - minValue) / (maxValue - minValue);
    return (max - min) * t + min;
}

const round = (number) => Math.round(number * 10_000) / 10_000;
function multiply(left, right) {
    return [
        left[0] * right[0][0] + left[1] * right[1][0] + left[2] * right[2][0],
        left[0] * right[0][1] + left[1] * right[1][1] + left[2] * right[2][1],
        left[0] * right[0][2] + left[1] * right[1][2] + left[2] * right[2][2],
    ];
}
class BezierPoint {
    /**
     * @description base point
     */
    point;
    /**
     * @description startTangent of the point
     * relative to base point
     */
    startTangent = {
        x: 0,
        y: 0,
    };
    /**
     * @description endTangent of the point
     * relative to base point
     */
    endTangent = {
        x: 0,
        y: 0,
    };
    constructor(payload) {
        this.point = {
            x: round(payload.point.x),
            y: round(payload.point.y),
        };
        if (payload.startTangent != null) {
            this.startTangent = {
                x: round(payload.startTangent.x),
                y: round(payload.startTangent.y),
            };
        }
        if (payload.endTangent != null) {
            this.endTangent = {
                x: round(payload.endTangent.x),
                y: round(payload.endTangent.y),
            };
        }
    }
    static fromAbsoluteJson(point) {
        const startTangent = (() => {
            if (point.startTangent != null) {
                return {
                    x: point.startTangent.x - point.point.x,
                    y: point.startTangent.y - point.point.y,
                };
            }
            return { x: 0, y: 0 };
        })();
        const endTangent = (() => {
            if (point.endTangent != null) {
                return {
                    x: point.endTangent.x - point.point.x,
                    y: point.endTangent.y - point.point.y,
                };
            }
            return { x: 0, y: 0 };
        })();
        return new BezierPoint({
            startTangent,
            point: point.point,
            endTangent,
        });
    }
    isLinear = () => {
        return (this.startTangent.x === 0 &&
            this.startTangent.y === 0 &&
            this.endTangent.x === 0 &&
            this.endTangent.y === 0);
    };
    // @NOTE: check if 2 tangents lies on the same line. We do this by check of square of triangle startTangent, point, endTangent
    isContinuous = () => {
        const ax = this.point.x + this.startTangent.x;
        const ay = this.point.y + this.startTangent.y;
        const bx = this.point.x;
        const by = this.point.y;
        const cx = this.point.x + this.endTangent.x;
        const cy = this.point.y + this.endTangent.y;
        return round((by - ay) * (cx - ax)) === round((bx - ax) * (cy - ay));
    };
    /**
     * @description rotate point related to origin: { x: 0, y: 0 }
     * @param payload.angle – angle in radians
     */
    rotateBy(angle) {
        const rotationMatrix = [
            [Math.cos(angle), -Math.sin(angle), 0],
            [Math.sin(angle), Math.cos(angle), 0],
            [0, 0, 1],
        ];
        this.transformByMatrix(rotationMatrix);
        return this;
    }
    rotatedBy(angle) {
        const newPoint = this.clone();
        newPoint.rotateBy(angle);
        return newPoint;
    }
    /**
     * @description shift point by provided offset
     * @param payload.offset – 2d point to offset
     */
    translateBy(offset) {
        this.point = {
            x: this.point.x + offset.x,
            y: this.point.y + offset.y,
        };
        return this;
    }
    translatedBy(offset) {
        const newPoint = this.clone();
        return newPoint.translateBy(offset);
    }
    scaleBy(scale) {
        const scaleMatrix = [
            [scale.x, 0, 0],
            [0, scale.y, 0],
            [0, 0, 1],
        ];
        this.transformByMatrix(scaleMatrix);
        return this;
    }
    scaledBy(scale) {
        const newPoint = this.clone();
        return newPoint.scaleBy(scale);
    }
    equals = (point) => {
        return (this.point.x === point.point.x &&
            this.point.y === point.point.y &&
            this.startTangent.x === point.startTangent.x &&
            this.startTangent.y === point.startTangent.y &&
            this.endTangent.x === point.endTangent.x &&
            this.endTangent.y === point.endTangent.y);
    };
    dotProduct = (point) => {
        const a = this.normalized().point;
        const b = point.normalized().point;
        return a.x * b.x + a.y * b.y;
    };
    angleBetween = (point) => {
        const magnitude = this.magnitude();
        const pointMagnitude = point.magnitude();
        if (magnitude === 0 || pointMagnitude === 0) {
            return 0;
        }
        const angleCos = R.clamp(-1, 1, (this.point.x * point.point.x + this.point.y * point.point.y) /
            (magnitude * pointMagnitude));
        return Math.acos(angleCos);
    };
    /**
     * @description convert current class to json representation
     */
    toJson = () => ({
        point: this.point,
        startTangent: this.startTangent,
        endTangent: this.endTangent,
    });
    /**
     * @description convert current class to json representation
     * with absolute coordinates
     */
    toAbsoluteJson = () => ({
        point: this.point,
        startTangent: {
            x: this.point.x + this.startTangent.x,
            y: this.point.y + this.startTangent.y,
        },
        endTangent: {
            x: this.point.x + this.endTangent.x,
            y: this.point.y + this.endTangent.y,
        },
    });
    clone = () => BezierPoint.fromAbsoluteJson(this.toAbsoluteJson());
    updateRelativeStartTangent = (point) => {
        this.startTangent = {
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            x: point.x,
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            y: point.y,
        };
        return this;
    };
    updateAbsoluteStartTangent = (point) => {
        this.startTangent = {
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            x: point.x - this.point.x,
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            y: point.y - this.point.y,
        };
        return this;
    };
    updateRelativeEndTangent = (point) => {
        this.endTangent = {
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            x: point.x,
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            y: point.y,
        };
        return this;
    };
    updateAbsoluteEndTangent = (point) => {
        this.endTangent = {
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            x: point.x - this.point.x,
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            y: point.y - this.point.y,
        };
        return this;
    };
    resetStartTangent = () => {
        this.startTangent = {
            x: 0,
            y: 0,
        };
        return this;
    };
    resetEndTangent = () => {
        this.endTangent = {
            x: 0,
            y: 0,
        };
        return this;
    };
    /**
     * @description flip tangents by assigning start = end, end = start
     */
    flipTangents = () => {
        const bufferTangent = R.clone(this.startTangent);
        this.startTangent = R.clone(this.endTangent);
        this.endTangent = bufferTangent;
        return this;
    };
    distanceTo = (point) => {
        const difference = new BezierPoint({
            point: {
                x: point.point.x - this.point.x,
                y: point.point.y - this.point.y,
            },
        });
        const distance = Math.sqrt(difference.point.x * difference.point.x +
            difference.point.y * difference.point.y);
        return distance;
    };
    magnitude = () => {
        return this.distanceTo(new BezierPoint({ point: { x: 0, y: 0 } }));
    };
    subtract = (point) => {
        this.point = {
            x: this.point.x - point.point.x,
            y: this.point.y - point.point.y,
        };
        return this;
    };
    subtractedBy = (point) => {
        const newPoint = this.clone();
        return newPoint.subtract(point);
    };
    add = (point) => {
        this.point = {
            x: this.point.x + point.point.x,
            y: this.point.y + point.point.y,
        };
        return this;
    };
    addedBy = (point) => {
        const newPoint = this.clone();
        return newPoint.add(point);
    };
    multiply = (number) => {
        this.point = {
            x: this.point.x * number,
            y: this.point.y * number,
        };
        return this;
    };
    multipliedBy = (number) => {
        const newPoint = this.clone();
        return newPoint.multiply(number);
    };
    normalized = () => {
        const length = this.magnitude();
        if (length === 0) {
            return new BezierPoint({
                point: {
                    x: 1,
                    y: 0,
                },
            });
        }
        return new BezierPoint({
            point: {
                x: this.point.x / length,
                y: this.point.y / length,
            },
        });
    };
    /**
     * @description helper for matrix transformation
     */
    transformByMatrix(transformMatrix) {
        const [x, y] = multiply([this.point.x, this.point.y, 1], transformMatrix);
        this.point = { x: round(x), y: round(y) };
        const [startTangentX, startTangentY] = multiply([this.startTangent.x, this.startTangent.y, 1], transformMatrix);
        this.startTangent = { x: round(startTangentX), y: round(startTangentY) };
        const [endTangentX, endTangentY] = multiply([this.endTangent.x, this.endTangent.y, 1], transformMatrix);
        this.endTangent = { x: round(endTangentX), y: round(endTangentY) };
        return this;
    }
}

const DEFAULT_POINTS = 4;
function generatePoints(payload) {
    const { sign, position, size, startAngle, endAngle, approximationPoints } = payload;
    const lengthCoefficient = (endAngle - startAngle) / (Math.PI * 2);
    // @NOTE: taken from https://stackoverflow.com/a/27863181
    const tangentDistance = (4 / 3) * Math.tan(Math.PI / (2 * approximationPoints)) * lengthCoefficient;
    const points = [];
    for (let i = 0; i < approximationPoints + 1; i += 1) {
        const point = new BezierPoint({
            point: {
                x: 0,
                // @NOTE: move point to right
                y: -1,
            },
            startTangent: {
                x: sign * tangentDistance,
                y: 0,
            },
            endTangent: {
                x: sign * -tangentDistance,
                y: 0,
            },
        })
            .rotateBy(sign * lerp(i / approximationPoints, startAngle, endAngle))
            .scaleBy({ x: size.x / 2, y: size.y / 2 })
            .translateBy({
            x: position.x + size.x / 2,
            y: position.y + size.y / 2,
        });
        points.push(point);
    }
    return points;
}
/**
 * @description generate arc by provided parameters and return bezier points
 */
function arcToBezier({ position, size, startAngle, endAngle, clockwise = true, innerRadius = 0, ellipse = false, approximatePoints = DEFAULT_POINTS, fixedPointsCount = false, }) {
    const sign = clockwise ? 1 : -1;
    // @NOTE: the more points we use the longest it take to calculate. Min is 4
    const approximationPoints = Math.round(lerpRange(Math.abs(endAngle - startAngle), 0, Math.PI * 2, 4, approximatePoints));
    const points = generatePoints({
        sign,
        position,
        size,
        startAngle,
        endAngle,
        approximationPoints: fixedPointsCount
            ? DEFAULT_POINTS
            : approximationPoints,
    });
    const isArc = Math.abs(endAngle - startAngle) < Math.PI * 2 || innerRadius !== 0;
    const strokeOnly = innerRadius === 1;
    // @NOTE: render if inner radius provided and arc is not full circle
    if (ellipse && isArc && strokeOnly === false) {
        points[0].resetStartTangent();
        points[points.length - 1].resetEndTangent();
        const newPoints = R.reverse(generatePoints({
            sign,
            position,
            size,
            startAngle,
            endAngle,
            approximationPoints: fixedPointsCount
                ? DEFAULT_POINTS
                : Math.round(lerp(innerRadius, 4, approximationPoints)),
        })).map((point) => point
            // @NOTE: shift back
            .translatedBy({
            x: -(position.x + size.x / 2),
            y: -(position.y + size.y / 2),
        })
            .scaledBy({ x: innerRadius, y: innerRadius })
            // @NOTE: shift forward
            .translatedBy({
            x: position.x + size.x / 2,
            y: position.y + size.y / 2,
        })
            .flipTangents());
        newPoints[0].resetStartTangent();
        newPoints[newPoints.length - 1].resetEndTangent();
        points.push(...newPoints);
    }
    if (fixedPointsCount) {
        return points;
    }
    // @NOTE: remove points with the same coords
    // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
    const cleanedPoints = [R.head(points).clone()];
    for (let i = 1; i < points.length; i += 1) {
        const prevPoint = points[i - 1];
        const point = points[i];
        if (prevPoint.equals(point)) {
            continue;
        }
        cleanedPoints.push(point.clone());
    }
    if (ellipse && isArc && strokeOnly === false) {
        // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
        if (R.head(cleanedPoints).equals(R.last(cleanedPoints)) === false) {
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            cleanedPoints.push(R.head(cleanedPoints).clone());
        }
        // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
        R.head(cleanedPoints).resetStartTangent();
        // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
        R.last(cleanedPoints).resetEndTangent();
    }
    return cleanedPoints;
}

function bezierPointsToPaperPath(payload) {
    const { regions } = payload;
    if (regions.length === 0) {
        return new paper.Path();
    }
    const path = new paper.Path();
    for (let i = 0; i < regions.length; i += 1) {
        const region = regions[i];
        const points = region.map((point) => point.toAbsoluteJson());
        for (let j = 0; j < points.length; j += 1) {
            const point = points[j];
            // @NOTE: set start position to correct coordinate
            if (j === 0) {
                path.moveTo(new paper.Point(point.point.x, point.point.y));
                continue;
            }
            const prevPoint = points[j - 1];
            const point0 = prevPoint.endTangent.x;
            const point1 = prevPoint.endTangent.y;
            const point2 = point.startTangent.x;
            const point3 = point.startTangent.y;
            const point4 = point.point.x;
            const point5 = point.point.y;
            // @NOTE: draw next point
            path.cubicCurveTo(new paper.Point(point0, point1), new paper.Point(point2, point3), new paper.Point(point4, point5));
            // @NOTE: close the spline if needed
            if (j === points.length - 1 && i === regions.length - 1) {
                // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
                const firstPoint = R.head(R.head(regions)).toAbsoluteJson();
                // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
                const lastPoint = R.last(R.last(regions)).toAbsoluteJson();
                const isClosed = firstPoint.point.x === lastPoint.point.x &&
                    firstPoint.point.y === lastPoint.point.y;
                if (isClosed) {
                    path.closePath();
                }
            }
        }
    }
    return path;
}

/**
 * @description convert provided bezier points to svg path
 */
function bezierPointsToSvgPath(payload) {
    const { regions } = payload;
    if (regions.length === 0) {
        return '';
    }
    let path = '';
    for (let i = 0; i < regions.length; i += 1) {
        const region = regions[i];
        const points = region.map((point) => point.toAbsoluteJson());
        for (let j = 0; j < points.length; j += 1) {
            const point = points[j];
            // @NOTE: set start position to correct coordinate
            if (j === 0) {
                path += `M ${point.point.x} ${point.point.y}`;
                continue;
            }
            const prevPoint = points[j - 1];
            const point0 = prevPoint.endTangent.x;
            const point1 = prevPoint.endTangent.y;
            const point2 = point.startTangent.x;
            const point3 = point.startTangent.y;
            const point4 = point.point.x;
            const point5 = point.point.y;
            // @NOTE: draw next point
            path += ` C ${point0} ${point1}, ${point2} ${point3}, ${point4} ${point5}`;
            // @NOTE: close the spline if needed
            if (j === points.length - 1 && i === regions.length - 1) {
                // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
                const firstPoint = R.head(R.head(regions)).toAbsoluteJson();
                // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
                const lastPoint = R.last(R.last(regions)).toAbsoluteJson();
                const isClosed = firstPoint.point.x === lastPoint.point.x &&
                    firstPoint.point.y === lastPoint.point.y;
                if (isClosed) {
                    path += ' Z';
                }
            }
        }
    }
    return path;
}

// @ts-nocheck
/**
 * Offset the start/terminal segment of a bezier curve
 * @param segment segment to offset
 * @param curve curve to offset
 * @param handleNormal the normal of the the line formed of two handles
 * @param offset offset value
 */
function offsetSegment(segment, curve, handleNormal, offset) {
    const isFirst = segment.curve === curve;
    // get offset vector
    const offsetVector = curve.getNormalAtTime(isFirst ? 0 : 1).multiply(offset);
    // get offset point
    const point = segment.point.add(offsetVector);
    const newSegment = new paper.Segment(point);
    // handleOut for start segment & handleIn for terminal segment
    const handle = (isFirst ? 'handleOut' : 'handleIn');
    newSegment[handle] = segment[handle].add(handleNormal.subtract(offsetVector).divide(2));
    return newSegment;
}
/**
 * Adaptive offset a curve by repeatly apply the approximation proposed by Tiller and Hanson.
 * @param curve curve to offset
 * @param offset offset value
 */
function adaptiveOffsetCurve(curve, offset) {
    const hNormal = new paper.Curve(curve.segment1.handleOut.add(curve.segment1.point), new paper.Point(0, 0), new paper.Point(0, 0), curve.segment2.handleIn.add(curve.segment2.point))
        .getNormalAtTime(0.5)
        .multiply(offset);
    const segment1 = offsetSegment(curve.segment1, curve, hNormal, offset);
    const segment2 = offsetSegment(curve.segment2, curve, hNormal, offset);
    // divide && re-offset
    const offsetCurve = new paper.Curve(segment1, segment2);
    // if the offset curve is not self intersected, divide it
    if (offsetCurve.getIntersections(offsetCurve).length === 0) {
        const threshold = Math.min(Math.abs(offset) / 10, 1);
        const midOffset = offsetCurve
            .getPointAtTime(0.5)
            .getDistance(curve.getPointAtTime(0.5));
        if (Math.abs(midOffset - Math.abs(offset)) > threshold) {
            const subCurve = curve.divideAtTime(0.5);
            if (subCurve != null) {
                return [
                    ...adaptiveOffsetCurve(curve, offset),
                    ...adaptiveOffsetCurve(subCurve, offset),
                ];
            }
        }
    }
    return [segment1, segment2];
}
/**
 * Create a round join segment between two adjacent segments.
 */
function makeRoundJoin(segment1, segment2, originPoint, radius) {
    const through = segment1.point
        .subtract(originPoint)
        .add(segment2.point.subtract(originPoint))
        .normalize(Math.abs(radius))
        .add(originPoint);
    const arc = new paper.Path.Arc({
        from: segment1.point,
        to: segment2.point,
        through,
        insert: false,
    });
    segment1.handleOut = arc.firstSegment.handleOut;
    segment2.handleIn = arc.lastSegment.handleIn;
    return arc.segments.length === 3 ? arc.segments[1] : null;
}
function det(p1, p2) {
    return p1.x * p2.y - p1.y * p2.x;
}
/**
 * Get the intersection point of point based lines
 */
function getPointLineIntersections(p1, p2, p3, p4) {
    const l1 = p1.subtract(p2);
    const l2 = p3.subtract(p4);
    const dl1 = det(p1, p2);
    const dl2 = det(p3, p4);
    return new paper.Point(dl1 * l2.x - l1.x * dl2, dl1 * l2.y - l1.y * dl2).divide(det(l1, l2));
}
/**
 * Connect two adjacent bezier curve, each curve is represented by two segments,
 * create different types of joins or simply removal redundant segment.
 */
function connectAdjacentBezier(segments1, segments2, origin, joinType, offset, limit) {
    const curve1 = new paper.Curve(segments1[0], segments1[1]);
    const curve2 = new paper.Curve(segments2[0], segments2[1]);
    const intersection = curve1.getIntersections(curve2);
    const distance = segments1[1].point.getDistance(segments2[0].point);
    if (origin.isSmooth()) {
        segments2[0].handleOut = segments2[0].handleOut.project(origin.handleOut);
        segments2[0].handleIn = segments1[1].handleIn.project(origin.handleIn);
        segments2[0].point = segments1[1].point.add(segments2[0].point).divide(2);
        segments1.pop();
    }
    else {
        if (intersection.length === 0) {
            if (distance > Math.abs(offset) * 0.1) {
                // connect
                switch (joinType) {
                    case 'miter':
                        const join = getPointLineIntersections(curve1.point2, curve1.point2.add(curve1.getTangentAtTime(1)), curve2.point1, curve2.point1.add(curve2.getTangentAtTime(0)));
                        // prevent sharp angle
                        const joinOffset = Math.max(join.getDistance(curve1.point2), join.getDistance(curve2.point1));
                        if (joinOffset < Math.abs(offset) * limit) {
                            segments1.push(new paper.Segment(join));
                        }
                        break;
                    case 'round':
                        const mid = makeRoundJoin(segments1[1], segments2[0], origin.point, offset);
                        if (mid) {
                            segments1.push(mid);
                        }
                        break;
                }
            }
            else {
                segments2[0].handleIn = segments1[1].handleIn;
                segments1.pop();
            }
        }
        else {
            const second1 = curve1.divideAt(intersection[0]);
            if (second1) {
                const join = second1.segment1;
                const second2 = curve2.divideAt(curve2.getIntersections(curve1)[0]);
                join.handleOut = second2
                    ? second2.segment1.handleOut
                    : segments2[0].handleOut;
                segments1.pop();
                segments2[0] = join;
            }
            else {
                segments2[0].handleIn = segments1[1].handleIn;
                segments1.pop();
            }
        }
    }
}
/**
 * Connect all the segments together.
 */
function connectBeziers(rawSegments, join, source, offset, limit) {
    const originSegments = source.segments;
    const first = rawSegments[0].slice();
    for (let i = 0; i < rawSegments.length - 1; ++i) {
        connectAdjacentBezier(rawSegments[i], rawSegments[i + 1], originSegments[i + 1], join, offset, limit);
    }
    if (source.closed) {
        connectAdjacentBezier(rawSegments[rawSegments.length - 1], first, originSegments[0], join, offset, limit);
        rawSegments[0][0] = first[0];
    }
    return rawSegments;
}
function reduceSingleChildCompoundPath(path) {
    if (path.children.length === 1) {
        path = path.children[0];
        path.remove(); // remove from parent, this is critical, or the style attributes will be ignored
    }
    return path;
}
/** Normalize a path, always clockwise, non-self-intersection, ignore really small components, and no one-component compound path. */
function normalize(path, areaThreshold = 0.01) {
    if (path.closed) {
        const ignoreArea = Math.abs(path.area * areaThreshold);
        if (!path.clockwise) {
            path.reverse();
        }
        path = path.unite(path, { insert: false });
        if (path instanceof paper.CompoundPath) {
            path.children
                .filter((c) => Math.abs(c.area) < ignoreArea)
                .forEach((c) => c.remove());
            if (path.children.length === 1) {
                return reduceSingleChildCompoundPath(path);
            }
        }
    }
    return path;
}
function isSameDirection(partialPath, fullPath) {
    const offset1 = partialPath.segments[0].location.offset;
    const offset2 = partialPath.segments[Math.max(1, Math.floor(partialPath.segments.length / 2))].location.offset;
    const sampleOffset = (offset1 + offset2) / 3;
    const originOffset1 = fullPath.getNearestLocation(partialPath.getPointAt(sampleOffset)).offset;
    const originOffset2 = fullPath.getNearestLocation(partialPath.getPointAt(2 * sampleOffset)).offset;
    return originOffset1 < originOffset2;
}
/** Remove self intersection when offset is negative by point direction dectection. */
function removeIntersection(path) {
    if (path.closed) {
        const newPath = path.unite(path, { insert: false });
        if (newPath instanceof paper.CompoundPath) {
            newPath.children
                .filter((c) => {
                if (c.segments.length > 1) {
                    return !isSameDirection(c, path);
                }
                else {
                    return true;
                }
            })
                .forEach((c) => c.remove());
            return reduceSingleChildCompoundPath(newPath);
        }
    }
    return path;
}
function getSegments(path) {
    if (path instanceof paper.CompoundPath) {
        return path.children.map((c) => c.segments).flat();
    }
    else {
        return path.segments;
    }
}
/**
 * Remove impossible segments in negative offset condition.
 */
function removeOutsiders(newPath, path) {
    const segments = getSegments(newPath).slice();
    segments.forEach((segment) => {
        if (!path.contains(segment.point)) {
            segment.remove();
        }
    });
}
function preparePath(path, offset) {
    const source = path.clone({ insert: false });
    source.reduce({});
    if (!path.clockwise) {
        source.reverse();
        offset = -offset;
    }
    return [source, offset];
}
function offsetSimpleShape(path, offset, join, limit) {
    let source;
    [source, offset] = preparePath(path, offset);
    const curves = source.curves.slice();
    const offsetCurves = curves
        .map((curve) => adaptiveOffsetCurve(curve, offset))
        .flat();
    const raws = [];
    for (let i = 0; i < offsetCurves.length; i += 2) {
        raws.push(offsetCurves.slice(i, i + 2));
    }
    const segments = connectBeziers(raws, join, source, offset, limit).flat();
    const newPath = removeIntersection(new paper.Path({ segments, insert: false, closed: path.closed }));
    newPath.reduce({});
    if (source.closed &&
        ((source.clockwise && offset < 0) || (!source.clockwise && offset > 0))) {
        removeOutsiders(newPath, path);
    }
    // recovery path
    if (source.clockwise !== path.clockwise) {
        newPath.reverse();
    }
    return normalize(newPath);
}
function makeRoundCap(from, to, offset) {
    const origin = from.point.add(to.point).divide(2);
    const normal = to.point
        .subtract(from.point)
        .rotate(-90, new paper.Point(0, 0))
        .normalize(offset);
    const through = origin.add(normal);
    const arc = new paper.Path.Arc({
        from: from.point,
        to: to.point,
        through,
        insert: false,
    });
    return arc.segments;
}
function connectSide(outer, inner, offset, cap) {
    if (outer instanceof paper.CompoundPath) {
        let cs = outer.children.map((c) => ({
            c,
            a: Math.abs(c.area),
        }));
        cs = cs.sort((c1, c2) => c2.a - c1.a);
        outer = cs[0].c;
    }
    const oSegments = outer.segments.slice();
    const iSegments = inner.segments.slice();
    switch (cap) {
        case 'round':
            const heads = makeRoundCap(iSegments[iSegments.length - 1], oSegments[0], offset);
            const tails = makeRoundCap(oSegments[oSegments.length - 1], iSegments[0], offset);
            const result = new paper.Path({
                segments: [...heads, ...oSegments, ...tails, ...iSegments],
                closed: true,
                insert: false,
            });
            result.reduce({});
            return result;
        default:
            return new paper.Path({
                segments: [...oSegments, ...iSegments],
                closed: true,
                insert: false,
            });
    }
}
function offsetSimpleStroke(path, offset, join, cap, limit) {
    offset = path.clockwise ? offset : -offset;
    const positiveOffset = offsetSimpleShape(path, offset, join, limit);
    const negativeOffset = offsetSimpleShape(path, -offset, join, limit);
    if (path.closed) {
        return positiveOffset.subtract(negativeOffset, {
            insert: false,
        });
    }
    else {
        let inner = negativeOffset;
        let holes = new Array();
        if (negativeOffset instanceof paper.CompoundPath) {
            holes = negativeOffset.children.filter((c) => c.closed);
            holes.forEach((h) => h.remove());
            inner = negativeOffset.children[0];
        }
        inner.reverse();
        let final = connectSide(positiveOffset, inner, offset, cap);
        if (holes.length > 0) {
            for (const hole of holes) {
                final = final.subtract(hole, { insert: false });
            }
        }
        return final;
    }
}
function getNonSelfItersectionPath(path) {
    if (path.closed) {
        return path.unite(path, { insert: false });
    }
    return path;
}
function offsetPath(path, offset, join, limit) {
    const nonSIPath = getNonSelfItersectionPath(path);
    let result = nonSIPath;
    if (nonSIPath instanceof paper.Path) {
        result = offsetSimpleShape(nonSIPath, offset, join, limit);
    }
    else {
        const offsetParts = nonSIPath.children.map((c) => {
            if (c.segments.length > 1) {
                if (!isSameDirection(c, path)) {
                    c.reverse();
                }
                let offseted = offsetSimpleShape(c, offset, join, limit);
                offseted = normalize(offseted);
                if (offseted.clockwise !== c.clockwise) {
                    offseted.reverse();
                }
                if (offseted instanceof paper.CompoundPath) {
                    offseted.applyMatrix = true;
                    return offseted.children;
                }
                else {
                    return offseted;
                }
            }
            else {
                return null;
            }
        });
        const children = offsetParts.flat().filter((c) => !!c);
        result = new paper.CompoundPath({ children, insert: false });
    }
    result.copyAttributes(nonSIPath, false);
    result.remove();
    return result;
}
function offsetStroke(path, offset, join, cap, limit) {
    const nonSIPath = getNonSelfItersectionPath(path);
    let result = nonSIPath;
    if (nonSIPath instanceof paper.Path) {
        result = offsetSimpleStroke(nonSIPath, offset, join, cap, limit);
    }
    else {
        const children = nonSIPath.children.flatMap((c) => {
            return offsetSimpleStroke(c, offset, join, cap, limit);
        });
        result = children.reduce((c1, c2) => c1.unite(c2, { insert: false }));
    }
    result.strokeWidth = 0;
    result.fillColor = nonSIPath.strokeColor;
    result.shadowBlur = nonSIPath.shadowBlur;
    result.shadowColor = nonSIPath.shadowColor;
    result.shadowOffset = nonSIPath.shadowOffset;
    return result;
}

/**
 * @file code taken from here: https://github.com/glenzli/paperjs-offset.
 * Repo was not updated for a while.
 */
// @ts-ignore
class PaperOffset {
    static offset(path, offset, options) {
        options = options || {};
        const newPath = offsetPath(path, offset, options.join || 'miter', options.limit || 10);
        if (options.insert === undefined) {
            options.insert = true;
        }
        if (options.insert) {
            (path.parent || paper.project.activeLayer).addChild(newPath);
        }
        return newPath;
    }
    static offsetStroke(path, offset, options) {
        options = options || {};
        const newPath = offsetStroke(path, offset, options.join || 'miter', options.cap || 'butt', options.limit || 10);
        if (options.insert === undefined) {
            options.insert = true;
        }
        if (options.insert) {
            (path.parent || paper.project.activeLayer).addChild(newPath);
        }
        return newPath;
    }
}

function lineToBezier({ position, size }) {
    const result = [
        new BezierPoint({ point: position }),
        new BezierPoint({
            point: {
                x: position.x + size.x,
                y: position.y + size.y,
            },
        }),
    ];
    return result;
}

function polygonToBezier({ position, size, pointCount, }) {
    const outerRadius = 1;
    const points = R.range(0, pointCount).map((idx) => {
        const angle = lerp(idx / pointCount, Math.PI, Math.PI * 3);
        const magnitude = outerRadius;
        return new BezierPoint({
            point: {
                x: 0,
                y: magnitude,
            },
        })
            .rotateBy(angle)
            .scaleBy({
            x: size.x / 2,
            y: size.y / 2,
        })
            .translateBy({
            x: position.x + size.x / 2,
            y: position.y + size.y / 2,
        });
    });
    // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
    return R.append(R.head(points), points);
}

/**
 * @description parse svg path and create array of bezier points
 * @param data svg path
 * @url https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths
 * @useant this function not handle ARCS
 */
function svgPathToBezierPoints(providedData) {
    const data = new paper.CompoundPath(providedData).pathData;
    const splitted = data.split(/(?=[MmVvHhLlCcSQTZz])/);
    const parsedCommands = splitted.map((rawCommand) => {
        const command = R.take(1, rawCommand);
        const points = R.drop(1, rawCommand)
            .replace(/\,/g, ' ')
            .split(' ')
            .filter((point) => point !== '')
            .map((point) => Number.parseFloat(point));
        return [command, ...points];
    });
    const bezierPoints = [];
    for (let i = 0; i < parsedCommands.length; i += 1) {
        const commandWithPoints = parsedCommands[i];
        const command = R.head(commandWithPoints);
        const points = R.drop(1, commandWithPoints);
        // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
        const prevPoint = R.last(R.defaultTo([], R.last(bezierPoints)));
        if (command === 'M' || command === 'm') {
            bezierPoints.push([]);
            bezierPoints[bezierPoints.length - 1].push(new BezierPoint({ point: { x: points[0], y: points[1] } }));
            continue;
        }
        if (command === 'V') {
            bezierPoints[bezierPoints.length - 1].push(new BezierPoint({ point: { x: prevPoint.point.x, y: points[0] } }));
            continue;
        }
        if (command === 'v') {
            bezierPoints[bezierPoints.length - 1].push(new BezierPoint({
                point: { x: prevPoint.point.x, y: prevPoint.point.y + points[0] },
            }));
            continue;
        }
        if (command === 'H') {
            bezierPoints[bezierPoints.length - 1].push(new BezierPoint({ point: { x: points[0], y: prevPoint.point.y } }));
            continue;
        }
        if (command === 'h') {
            bezierPoints[bezierPoints.length - 1].push(new BezierPoint({
                point: { x: prevPoint.point.x + points[0], y: prevPoint.point.y },
            }));
            continue;
        }
        if (command === 'L') {
            bezierPoints[bezierPoints.length - 1].push(new BezierPoint({ point: { x: points[0], y: points[1] } }));
            continue;
        }
        if (command === 'l') {
            bezierPoints[bezierPoints.length - 1].push(new BezierPoint({
                point: {
                    x: prevPoint.point.x + points[0],
                    y: prevPoint.point.y + points[1],
                },
            }));
            continue;
        }
        if (command === 'C') {
            prevPoint.updateAbsoluteEndTangent({
                x: points[0],
                y: points[1],
            });
            bezierPoints[bezierPoints.length - 1].push(BezierPoint.fromAbsoluteJson({
                point: { x: points[4], y: points[5] },
                startTangent: { x: points[2], y: points[3] },
            }));
            continue;
        }
        if (command === 'c') {
            const absolutePoint = prevPoint.toAbsoluteJson();
            prevPoint.updateAbsoluteEndTangent({
                x: absolutePoint.point.x + points[0],
                y: absolutePoint.point.y + points[1],
            });
            bezierPoints[bezierPoints.length - 1].push(BezierPoint.fromAbsoluteJson({
                point: {
                    x: absolutePoint.point.x + points[4],
                    y: absolutePoint.point.y + points[5],
                },
                startTangent: {
                    x: absolutePoint.point.x + points[2],
                    y: absolutePoint.point.y + points[3],
                },
            }));
            continue;
        }
        if (command === 'S') {
            bezierPoints[bezierPoints.length - 1].push(BezierPoint.fromAbsoluteJson({
                startTangent: prevPoint.toAbsoluteJson().endTangent,
                point: { x: points[2], y: points[3] },
                endTangent: { x: points[0], y: points[1] },
            }));
            continue;
        }
        if (command === 's') {
            const absolutePoint = prevPoint.toAbsoluteJson();
            bezierPoints[bezierPoints.length - 1].push(BezierPoint.fromAbsoluteJson({
                startTangent: absolutePoint.endTangent,
                point: {
                    x: absolutePoint.point.x + points[2],
                    y: absolutePoint.point.y + points[3],
                },
                endTangent: {
                    x: absolutePoint.point.x + points[0],
                    y: absolutePoint.point.y + points[1],
                },
            }));
            continue;
        }
        if (command === 'Q') {
            prevPoint.updateAbsoluteEndTangent({ x: points[0], y: points[1] });
            bezierPoints[bezierPoints.length - 1].push(BezierPoint.fromAbsoluteJson({
                startTangent: { x: points[0], y: points[1] },
                point: { x: points[2], y: points[3] },
            }));
            continue;
        }
        if (command === 'T') {
            prevPoint.updateAbsoluteEndTangent({ x: points[0], y: points[1] });
            bezierPoints[bezierPoints.length - 1].push(BezierPoint.fromAbsoluteJson({
                startTangent: { x: points[0], y: points[1] },
                point: { x: points[2], y: points[3] },
            }));
        }
    }
    // const withoutTwoIdenticalPointsInARow = R.uniqWith(
    //   (left, right) => left.equals(right),
    //   bezierPoints
    // )
    const preparedPoints = bezierPoints; // withoutTwoIdenticalPointsInARow
    return preparedPoints
        .map((points) => {
        const newPoints = R.clone(points);
        // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
        const lastCommand = R.last(parsedCommands);
        if (lastCommand[0] === 'Z' || lastCommand[0] === 'z') {
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            newPoints.push(R.head(newPoints));
        }
        return newPoints;
    })
        .filter((points) => points.length > 0);
}

/**
 * @todo add docs
 */
function roundPoints(payload) {
    const { points: [A, B, C], radius, } = payload;
    const ab = B.subtractedBy(A);
    const bc = C.subtractedBy(B);
    const ba = A.subtractedBy(B);
    const shortestEdge = R.min(ab.magnitude(), bc.magnitude());
    const angle = ab.angleBetween(bc);
    // scalars
    const EA = radius;
    const tan = Math.tan(angle / 2) || 1;
    const AB = EA / tan;
    const BC = AB;
    const BD = AB * Math.cos(angle / 2);
    const BF = BD * Math.cos(angle / 2);
    const FD = BD * Math.sin(angle / 2);
    const CE = FD / (BF / BC);
    const cornerRadius = CE;
    const perpendicular = ab.rotatedBy(Math.PI / 2);
    const isClockwise = bc.dotProduct(perpendicular) >= 0;
    const sign = isClockwise ? -1 : 1;
    const newAB = cornerRadius * tan;
    const maxLength = R.min(newAB, shortestEdge / 2);
    const modifiedCornerRadius = maxLength / tan;
    const APoint = ba
        .normalized()
        .multiply(modifiedCornerRadius * tan)
        .addedBy(B);
    const EPoint = ba
        .normalized()
        .rotatedBy((sign * Math.PI) / 2)
        .multiply(modifiedCornerRadius)
        .addedBy(APoint);
    const circleCenter = EPoint;
    const abAxisAngle = ab.angleBetween(new BezierPoint({ point: { x: 1, y: 0 } }));
    return arcToBezier({
        position: {
            x: -modifiedCornerRadius,
            y: -modifiedCornerRadius,
        },
        size: { x: modifiedCornerRadius * 2, y: modifiedCornerRadius * 2 },
        startAngle: 0,
        endAngle: Math.abs(angle),
        clockwise: isClockwise,
    })
        .map((point) => {
        const currentSign = ab.point.y > 0 ? -1 : 1;
        const updatedPoint = point.rotatedBy(currentSign * abAxisAngle);
        if (!isClockwise) {
            return updatedPoint;
        }
        return updatedPoint.rotatedBy(Math.PI);
    })
        .map((point) => point.translatedBy(circleCenter.point));
}
/**
 * @description round points of any svg path. Most of the logic taken from this article
 * @url https://observablehq.com/@daformat/rounding-polygon-corners
 */
function roundSvgPath({ data, radius, debug = false }) {
    if (radius < 1) {
        return typeof data === 'string'
            ? data
            : bezierPointsToSvgPath({ regions: data });
    }
    if (debug) {
        console.log('data', data);
    }
    const pointsToRoundArray = typeof data === 'string' ? svgPathToBezierPoints(data) : data;
    if (debug) {
        console.log('converted points array', pointsToRoundArray);
    }
    const map = pointsToRoundArray.map((pointsToRound) => {
        if (pointsToRound.length < 3) {
            return pointsToRound;
        }
        // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
        const roundedPoints = [R.head(pointsToRound).clone()];
        const length = pointsToRound.length;
        for (let i = 1; i < length - 1; i += 1) {
            const currentPoint = pointsToRound[i].clone();
            if (debug) {
                console.log({
                    currentPoint,
                    isContinuous: currentPoint.isContinuous(),
                    isLinear: currentPoint.isLinear(),
                });
            }
            if (currentPoint.isContinuous() && currentPoint.isLinear() === false) {
                roundedPoints.push(currentPoint);
                continue;
            }
            const prevPoint = pointsToRound[i - 1].clone();
            const nextPoint = pointsToRound[i + 1].clone();
            roundedPoints.push(...roundPoints({
                points: [
                    new BezierPoint({ point: prevPoint.toAbsoluteJson().endTangent }),
                    currentPoint,
                    new BezierPoint({ point: nextPoint.toAbsoluteJson().startTangent }),
                ],
                radius,
            }));
        }
        // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
        const isClosed = R.last(pointsToRound).equals(R.head(pointsToRound));
        if (isClosed) {
            const predLastIdx = pointsToRound.length - 2;
            const firstIdx = 1;
            // @NOTE: required to remove not required point in not-circular shapes
            if (pointsToRound[predLastIdx].isContinuous() &&
                pointsToRound[predLastIdx].isLinear() &&
                pointsToRound[firstIdx].isContinuous() &&
                pointsToRound[firstIdx].isLinear()) {
                roundedPoints.shift();
            }
            const points = roundPoints({
                points: [
                    new BezierPoint({
                        point: pointsToRound[predLastIdx].toAbsoluteJson().endTangent,
                    }),
                    // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
                    R.last(pointsToRound),
                    new BezierPoint({
                        point: pointsToRound[firstIdx].toAbsoluteJson().startTangent,
                    }),
                ],
                radius,
            });
            roundedPoints.push(...points);
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            roundedPoints.push(R.head(roundedPoints));
        }
        else {
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            roundedPoints.push(R.last(pointsToRound));
        }
        const withoutTwoIdenticalPointsInARow = R.uniqWith((left, right) => left.equals(right), roundedPoints);
        if (isClosed) {
            withoutTwoIdenticalPointsInARow.push(
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            R.head(withoutTwoIdenticalPointsInARow));
        }
        return withoutTwoIdenticalPointsInARow;
    });
    if (debug) {
        console.log('map', map);
    }
    const result = bezierPointsToSvgPath({ regions: map });
    if (debug) {
        console.log('result', result);
    }
    return result;
}

function starToBezier({ position, size, pointCount, innerRadius, }) {
    const outerRadius = 1;
    const points = R.range(0, pointCount * 2).map((idx) => {
        const isEven = idx % 2 === 0;
        const angle = lerp(idx / (pointCount * 2), Math.PI, Math.PI * 3);
        const magnitude = isEven ? outerRadius : innerRadius;
        return new BezierPoint({
            point: {
                x: 0,
                y: magnitude,
            },
        })
            .rotateBy(angle)
            .scaleBy({
            x: size.x / 2,
            y: size.y / 2,
        })
            .translateBy({
            x: position.x + size.x / 2,
            y: position.y + size.y / 2,
        });
    });
    // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
    return R.append(R.head(points), points);
}

/**
 * Used to protect subdivision operations
 */
const protect = (number) => (number === 0 ? 1 : number);

const getSizeMatrix = (entity, time) => {
    const initialSize = getSize(entity);
    const size = getSize(entity, time);
    // @TODO: migrate to anchor point percents
    // const anchorPointPercents = getAnchorPoint(entity, time)
    // const anchorPoint = {
    //   x: anchorPointPercents.x * size.x,
    //   y: anchorPointPercents.y * size.y,
    // }
    const anchorPoint = getAnchorPoint(entity, time);
    const delta = {
        x: (initialSize.x - size.x) * (anchorPoint.x / protect(initialSize.x)),
        y: (initialSize.y - size.y) * (anchorPoint.y / protect(initialSize.y)),
    };
    return new paper.Matrix(multipliedMatrices(TranslateMatrix(delta.x, delta.y)));
};

// @TODO: IMPORTANT improve rounding of ellipses in arcs
function getEllipseData(payload) {
    const { entity, time, optimizedPath, fixedPointsCount, isReversed = false, } = payload;
    const sweepAspect = entity.getAspectOrThrow(SweepAspect);
    const cornerRadiusAspect = entity.getAspectOrThrow(CornerRadiusAspect);
    // @NOTE: startAngle calculates in degrees
    const startAngleInDegrees = sweepAspect.startAngle.getValue(time) + 90;
    // @NOTE: endAngle calculates in percents
    const endAngleInDegrees = startAngleInDegrees + sweepAspect.endAngle.getValue(time) * 360;
    const startingAngle = (startAngleInDegrees / 180) * Math.PI;
    const endingAngle = (endAngleInDegrees / 180) * Math.PI;
    const innerRadius = sweepAspect.innerRadius.getValue(time);
    const size = getSize(entity, time);
    const cornerRadius = cornerRadiusAspect.radius.getValue(time);
    const protectedSize = {
        x: Math.max(0.1, size.x),
        y: Math.max(0.1, size.y),
    };
    const matrix = getSizeMatrix(entity, time);
    const isArc = Math.abs(endAngleInDegrees - startAngleInDegrees) < 360;
    const isDonut = isArc === false && innerRadius !== 0;
    if (isDonut) {
        const outer = arcToBezier({
            position: { x: 0, y: 0 },
            size: protectedSize,
            startAngle: startingAngle,
            endAngle: endingAngle,
            innerRadius: 0,
            clockwise: false,
            ellipse: true,
            approximatePoints: optimizedPath ? 4 : undefined,
            fixedPointsCount,
        });
        const inner = arcToBezier({
            position: {
                x: (protectedSize.x * (1 - innerRadius)) / 2,
                y: (protectedSize.y * (1 - innerRadius)) / 2,
            },
            size: {
                x: protectedSize.x * innerRadius,
                y: protectedSize.y * innerRadius,
            },
            startAngle: startingAngle,
            endAngle: endingAngle,
            innerRadius: 0,
            clockwise: false,
            ellipse: true,
            approximatePoints: optimizedPath ? 4 : undefined,
            fixedPointsCount,
        });
        const outerPath = bezierPointsToPaperPath({
            regions: [outer],
        });
        const innerPath = bezierPointsToPaperPath({
            regions: [inner],
        });
        outerPath.transform(matrix);
        innerPath.transform(matrix);
        if (isReversed) {
            outerPath.reverse();
            innerPath.reverse();
        }
        const outerResult = isArc === false
            ? outerPath.pathData
            : roundSvgPath({
                data: outerPath.pathData,
                radius: cornerRadius,
            });
        const innerResult = isArc === false
            ? innerPath.pathData
            : roundSvgPath({
                data: innerPath.pathData,
                radius: cornerRadius,
            });
        return [
            {
                data: `${outerResult}${innerResult}`,
                windingRule: 'EVENODD',
            },
        ];
    }
    const bezierPoints = arcToBezier({
        position: { x: 0, y: 0 },
        size: protectedSize,
        startAngle: startingAngle,
        endAngle: endingAngle,
        innerRadius,
        clockwise: false,
        ellipse: true,
        approximatePoints: optimizedPath ? 4 : undefined,
        fixedPointsCount,
    });
    const data = bezierPointsToPaperPath({ regions: [bezierPoints] });
    const path = new paper.CompoundPath(data);
    path.transform(matrix);
    if (isReversed) {
        path.reverse();
    }
    const result = isArc === false
        ? path.pathData
        : roundSvgPath({
            data: path.pathData,
            radius: cornerRadius,
            // debug: node.name === 'Ellipse 9105',
        });
    return [
        {
            data: result,
            windingRule: 'NONZERO',
        },
    ];
}

/**
 * About squircles by Figma.
 * @url https://medium.com/figma-design/desperately-seeking-squircles-8eb8db9b654b
 */
function getTangentCoefficient() {
    // @NOTE: So for 4 points it is (4/3)*tan(pi/8) = 4*(sqrt(2)-1)/3 = 0.552284749831.
    // @URL: https://stackoverflow.com/a/27863181
    return 0.552284749831;
}
function getPointCoefficient(t) {
    // @NOTE: 0.28 is a magic variable. Was picked up with the help of Figma
    return lerp(t, 0.28, 0);
}
function getClampedBorderRadius(payload) {
    const { width, height, radiusLeft, radiusCenter, radiusRight } = payload;
    const side = R.min(width, height);
    const max = R.max(radiusLeft, radiusRight);
    const clampedCenter = R.max(1, R.min(side, radiusCenter));
    const clampedMax = R.max(1, R.min(side, max));
    if (clampedCenter + clampedMax > side) {
        return (radiusCenter / R.max(1, radiusCenter + max)) * side;
    }
    return radiusCenter;
}
// @TODO: Remove 0.01 once we have custom rounded for vector paths
function prepareAnimated(value) {
    return R.max(0.01, value);
}
function generateRoundedRect(payload) {
    const x = 0;
    const y = 0;
    const w = payload.width;
    const h = payload.height;
    const min = Math.min(w, h) / 2;
    const { cornerSmoothEnabled } = payload;
    if (payload.type === 'independent') {
        const tlr = payload.topLeftRadius;
        const trr = payload.topRightRadius;
        const brr = payload.bottomRightRadius;
        const blr = payload.bottomLeftRadius;
        const tc = getTangentCoefficient();
        const pctl = cornerSmoothEnabled && min !== 0 ? getPointCoefficient(tlr / min) : 0;
        const pctr = cornerSmoothEnabled && min !== 0 ? getPointCoefficient(trr / min) : 0;
        const pcbr = cornerSmoothEnabled && min !== 0 ? getPointCoefficient(brr / min) : 0;
        const pcbl = cornerSmoothEnabled && min !== 0 ? getPointCoefficient(blr / min) : 0;
        // @NOTE: drawing from top left point clockwise:
        // top-left -> top-right -> bottom-right -> bottom-left
        // 3 is a magic number as well.
        const path = new paper.Path();
        path.moveTo(new paper.Point(x + tlr + tlr * pctl, y));
        path.lineTo(new paper.Point(x + w - trr - trr * pctr, y));
        path.cubicCurveTo(new paper.Point(x + w - trr + trr * tc + (trr * pctr) / 3, y), new paper.Point(x + w, y + trr - trr * tc - (trr * pctr) / 3), new paper.Point(x + w, y + trr + trr * pctr));
        path.lineTo(new paper.Point(x + w, y + h - brr - brr * pcbr));
        path.cubicCurveTo(new paper.Point(x + w, y + h - brr + brr * tc + (brr * pcbr) / 3), new paper.Point(x + w - brr + brr * tc + (brr * pcbr) / 3, y + h), new paper.Point(x + w - brr - brr * pcbr, y + h));
        path.lineTo(new paper.Point(x + blr + blr * pcbl, y + h));
        path.cubicCurveTo(new paper.Point(x + blr - blr * tc - (blr * pcbl) / 3, y + h), new paper.Point(x, y + h - blr + blr * tc + (blr * pcbl) / 3), new paper.Point(x, y + h - blr - blr * pcbl));
        path.lineTo(new paper.Point(x, y + tlr + tlr * pctl));
        path.cubicCurveTo(new paper.Point(x, y + tlr - tlr * tc - (tlr * pctl) / 3), new paper.Point(x + tlr - tlr * tc - (tlr * pctl) / 3, y), new paper.Point(x + tlr + tlr * pctl, y));
        path.closePath();
        return path;
    }
    const tc = getTangentCoefficient();
    const br = payload.borderRadius;
    const pc = cornerSmoothEnabled && min !== 0 ? getPointCoefficient(br / min) : 0;
    // @NOTE: drawing from top left point clockwise:
    // top-left -> top-right -> bottom-right -> bottom-left
    // 3 is a magic number as well.
    const path = new paper.Path();
    path.moveTo(new paper.Point(x + br + br * pc, y));
    path.lineTo(new paper.Point(x + w - br - br * pc, y));
    path.cubicCurveTo(new paper.Point(x + w - br + br * tc + (br * pc) / 3, y), new paper.Point(x + w, y + br - br * tc - (br * pc) / 3), new paper.Point(x + w, y + br + br * pc));
    path.lineTo(new paper.Point(x + w, y + h - br - br * pc));
    path.cubicCurveTo(new paper.Point(x + w, y + h - br + br * tc + (br * pc) / 3), new paper.Point(x + w - br + br * tc + (br * pc) / 3, y + h), new paper.Point(x + w - br - br * pc, y + h));
    path.lineTo(new paper.Point(x + br + br * pc, y + h));
    path.cubicCurveTo(new paper.Point(x + br - br * tc - (br * pc) / 3, y + h), new paper.Point(x, y + h - br + br * tc + (br * pc) / 3), new paper.Point(x, y + h - br - br * pc));
    path.lineTo(new paper.Point(x, y + br + br * pc));
    path.cubicCurveTo(new paper.Point(x, y + br - br * tc - (br * pc) / 3), new paper.Point(x + br - br * tc - (br * pc) / 3, y), new paper.Point(x + br + br * pc, y));
    path.closePath();
    return path;
}
function getRectangleData(payload) {
    const { entity, time, ignoreCornerRadius = false, isReversed = false, } = payload;
    const size = getSize(entity, time);
    const matrix = getSizeMatrix(entity, time);
    // @TODO: make it as .hasComponent check so component can be optional
    const isSmoothCornersEnabled = entity.getComponentOrThrow(SmoothCornerRadiusComponent).value;
    if (entity.getAspectOrThrow(IndividualCornerRadiusAspect)
        .isIndividualCornersEnabled) {
        const individualCornerRadiusAspect = entity.getAspectOrThrow(IndividualCornerRadiusAspect);
        const topLeftRadius = individualCornerRadiusAspect.topLeftRadius.getValue(time);
        const topRightRadius = individualCornerRadiusAspect.topRightRadius.getValue(time);
        const bottomRightRadius = individualCornerRadiusAspect.bottomRightRadius.getValue(time);
        const bottomLeftRadius = individualCornerRadiusAspect.bottomLeftRadius.getValue(time);
        const path = generateRoundedRect({
            width: size.x,
            height: size.y,
            type: 'independent',
            topLeftRadius: ignoreCornerRadius
                ? 0
                : prepareAnimated(getClampedBorderRadius({
                    width: size.x,
                    height: size.y,
                    radiusLeft: bottomLeftRadius,
                    radiusCenter: topLeftRadius,
                    radiusRight: topRightRadius,
                })),
            topRightRadius: ignoreCornerRadius
                ? 0
                : prepareAnimated(getClampedBorderRadius({
                    width: size.x,
                    height: size.y,
                    radiusLeft: topLeftRadius,
                    radiusCenter: topRightRadius,
                    radiusRight: bottomRightRadius,
                })),
            bottomLeftRadius: ignoreCornerRadius
                ? 0
                : prepareAnimated(getClampedBorderRadius({
                    width: size.x,
                    height: size.y,
                    radiusLeft: bottomRightRadius,
                    radiusCenter: bottomLeftRadius,
                    radiusRight: topLeftRadius,
                })),
            bottomRightRadius: ignoreCornerRadius
                ? 0
                : prepareAnimated(getClampedBorderRadius({
                    width: size.x,
                    height: size.y,
                    radiusLeft: topRightRadius,
                    radiusCenter: bottomRightRadius,
                    radiusRight: bottomLeftRadius,
                })),
            cornerSmoothEnabled: isSmoothCornersEnabled,
        });
        const rectangle = new paper.CompoundPath(path);
        rectangle.transform(matrix);
        if (isReversed) {
            rectangle.reverse();
        }
        return [
            {
                data: rectangle.pathData,
                windingRule: 'NONZERO',
            },
        ];
    }
    const cornerRadius = entity
        .getAspectOrThrow(CornerRadiusAspect)
        .radius.getValue(time);
    const rectangle = generateRoundedRect({
        width: size.x,
        height: size.y,
        type: 'union',
        borderRadius: ignoreCornerRadius
            ? 0
            : prepareAnimated(getClampedBorderRadius({
                width: size.x,
                height: size.y,
                radiusLeft: cornerRadius,
                radiusCenter: cornerRadius,
                radiusRight: cornerRadius,
            })),
        cornerSmoothEnabled: isSmoothCornersEnabled,
    });
    rectangle.transform(matrix);
    if (isReversed) {
        rectangle.reverse();
    }
    return [
        {
            data: rectangle.pathData,
            windingRule: 'NONZERO',
        },
    ];
}

function getGroupData(payload) {
    const { entity, time, isReversed = false } = payload;
    const size = getSize(entity, time);
    const matrix = getSizeMatrix(entity, time);
    const rectangle = generateRoundedRect({
        width: size.x,
        height: size.y,
        type: 'union',
        borderRadius: 0,
        cornerSmoothEnabled: false,
    });
    rectangle.transform(matrix);
    if (isReversed) {
        rectangle.reverse();
    }
    return [
        {
            data: rectangle.pathData,
            windingRule: 'NONZERO',
        },
    ];
}

function getLineData(payload) {
    const { entity, time, isReversed = false } = payload;
    const strokeWeight = entity
        .getAspectOrThrow(StrokesAspect)
        .strokeWeight.getValue(time);
    const size = getSize(entity, time);
    const matrix = getSizeMatrix(entity, time);
    const bezierPoints = lineToBezier({
        position: { x: strokeWeight / 2, y: -strokeWeight / 2 },
        size: {
            x: size.x - strokeWeight,
            y: size.y,
        },
    });
    const data = bezierPointsToSvgPath({
        regions: [bezierPoints],
    });
    const path = new paper.CompoundPath(data);
    path.transform(matrix);
    if (isReversed) {
        path.reverse();
    }
    return [
        {
            data: path.pathData,
            windingRule: 'NONZERO',
        },
    ];
}

function getPolygonData(payload) {
    const { entity, time, isReversed = false } = payload;
    const size = getSize(entity, time);
    const pointCount = entity
        .getAspectOrThrow(PolygonAspect)
        .pointCount.getValue(time);
    const cornerRadius = entity
        .getAspectOrThrow(CornerRadiusAspect)
        .radius.getValue(time);
    const matrix = getSizeMatrix(entity, time);
    const bezierPoints = polygonToBezier({
        position: { x: 0, y: 0 },
        size,
        pointCount: round$1(pointCount, { fixed: 0 }),
    });
    const rounded = roundSvgPath({
        data: [bezierPoints],
        radius: cornerRadius,
    });
    const path = new paper.CompoundPath(rounded);
    path.transform(matrix);
    if (isReversed) {
        path.reverse();
    }
    return [
        {
            data: path.pathData,
            windingRule: 'NONZERO',
        },
    ];
}

function getStarData(payload) {
    const { entity, time, isReversed = false } = payload;
    const size = getSize(entity, time);
    const pointCount = entity
        .getAspectOrThrow(StarAspect)
        .pointCount.getValue(time);
    const innerRadius = entity
        .getAspectOrThrow(StarAspect)
        .innerRadius.getValue(time);
    const cornerRadius = entity
        .getAspectOrThrow(CornerRadiusAspect)
        .radius.getValue(time);
    const matrix = getSizeMatrix(entity, time);
    const bezierPoints = starToBezier({
        position: { x: 0, y: 0 },
        size,
        pointCount: round$1(pointCount, { fixed: 0 }),
        innerRadius,
    });
    const rounded = roundSvgPath({
        data: [bezierPoints],
        radius: cornerRadius,
    });
    const path = new paper.CompoundPath(rounded);
    path.transform(matrix);
    if (isReversed) {
        path.reverse();
    }
    return [
        {
            data: path.pathData,
            windingRule: 'NONZERO',
        },
    ];
}

function getRange(payload) {
    const { path, start, end } = payload;
    const internalPath = path.clone();
    const length = internalPath.length;
    if (internalPath.closed) {
        internalPath.splitAt(0);
    }
    const finalPath = new paper.Path();
    // @NOTE: after first split we get the right part
    const startFrom = internalPath.splitAt(length * start);
    if (end < 1) {
        // @NOTE: after second split we get the left part
        startFrom.splitAt(length * (end - start));
    }
    startFrom.segments.forEach((segment) => {
        finalPath.add(segment);
    });
    return finalPath;
}
function trimPath(payload) {
    // @ts-ignore
    const { data: providedData, offset, debug = false } = payload;
    // @NOTE: required to split multiple paths to separated
    // For example M,C,C,C,M,C,C,C -> [[M,C,C,C], [M,C,C,C]]
    const data = providedData.flatMap((path) => {
        const chunks = path.data.split('M');
        return R.drop(1, chunks).map((chunk) => ({
            data: `M${chunk}`,
            windingRule: path.windingRule,
        }));
    });
    if (payload.start <= 0 && payload.end >= 1) {
        return providedData;
    }
    const rawStart = offset + payload.start;
    const rawEnd = offset + payload.end;
    const start = Math.min(rawStart, rawEnd);
    const end = Math.max(rawStart, rawEnd);
    const breakStart = start < 0 && end >= 0;
    const breakEnd = start < 1 && end >= 1;
    return data.flatMap(function mapVectorPath(vectorPath) {
        const sourcePath = new paper.Path(vectorPath.data);
        const trimmedPath = new paper.CompoundPath('');
        // @NOTE: required to handle cases when user provider path as a dot.
        // Related to ANI-2245.
        if (sourcePath.length === 0) {
            return vectorPath;
        }
        if (payload.isPathReversed) {
            sourcePath.reverse();
        }
        if (breakStart) {
            const newPath1 = getRange({
                path: sourcePath,
                start: start + 1,
                end: 1,
            });
            const newPath2 = getRange({
                path: sourcePath,
                start: 0,
                end: end,
            });
            trimmedPath.addChild(newPath1);
            trimmedPath.addChild(newPath2);
        }
        if (breakStart === false && breakEnd === false) {
            const newPath1 = getRange({
                path: sourcePath,
                start: (start + 1) % 1,
                end: (end + 1) % 1,
            });
            trimmedPath.addChild(newPath1);
        }
        if (breakEnd) {
            const newPath1 = getRange({
                path: sourcePath,
                start: start,
                end: 1,
            });
            const newPath2 = getRange({
                path: sourcePath,
                start: 0,
                end: end - 1,
            });
            trimmedPath.addChild(newPath1);
            trimmedPath.addChild(newPath2);
        }
        return [
            {
                data: trimmedPath.pathData,
                windingRule: vectorPath.windingRule,
            },
        ];
    });
}

function getVectorData(payload) {
    const { entity, time, isReversed = false } = payload;
    // @NOTE: CornerRadiusAspect does not exist in Text nodes that are used as vectors when mapped from the old model.
    // Check for comopnent required because aspect throws an error if value is undefined.
    // @TODO: probably we have to refactor this logic and use something like `getCornerRadius(time)`
    const cornerRadius = entity.hasComponent(CornerRadiusComponent)
        ? (entity.getAspect(CornerRadiusAspect)?.radius.getValue(time) ?? 0)
        : 0;
    const vectorPaths = entity.getComponentOrThrow(VectorPathsComponent).value;
    if (vectorPaths.length === 0) {
        return [];
    }
    return vectorPaths.map((vectorPath) => {
        const preparedPathData = cornerRadius !== 0
            ? roundSvgPath({
                data: vectorPath.data,
                radius: cornerRadius,
                // debug: node.name === 'Star 1',
            })
            : vectorPath.data;
        const paperPath = new paper.CompoundPath(preparedPathData);
        // @NOTE: simplify path
        // @TODO: rebuild algorithm
        // paperPath.children.forEach((p) => simplifyPath(p as paper.Path))
        if (isReversed) {
            paperPath.reverse();
        }
        if (entity.getComponentOrThrow(SizeBehaviourComponent).value ===
            NodeSizeBehaviour.Ignore) {
            return {
                data: paperPath.pathData,
                windingRule: vectorPath.windingRule,
            };
        }
        const size = getSize(entity);
        const actualSize = getSize(entity, time);
        // @TODO: migrate to anchor point percents
        // const anchorPointPercents = getAnchorPoint(entity, time)
        // const anchorPoint = {
        //   x: anchorPointPercents.x * size.x,
        //   y: anchorPointPercents.y * size.y,
        // }
        const anchorPoint = getAnchorPoint(entity, time);
        const sizeScale = {
            x: actualSize.x / protect(size.x),
            y: actualSize.y / protect(size.y),
        };
        const matrix = new paper.Matrix(multipliedMatrices(TranslateMatrix(-anchorPoint.x, -anchorPoint.y), ScaleMatrix(sizeScale.x, sizeScale.y), TranslateMatrix(anchorPoint.x, anchorPoint.y)));
        paperPath.transform(matrix);
        return {
            data: paperPath.pathData,
            windingRule: vectorPath.windingRule,
        };
    });
}

// @NOTE: check this file and remove unused functions if we proceed with current solution
function extractCurves(payload) {
    const { type, curves } = payload;
    switch (type) {
        case 'top':
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            return [curves.at(-1), curves.at(0), curves.at(1)];
        case 'right':
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            return [curves.at(1), curves.at(2), curves.at(3)];
        case 'bottom':
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            return [curves.at(3), curves.at(4), curves.at(5)];
        case 'left':
            // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
            return [curves.at(5), curves.at(6), curves.at(7)];
    }
}
// @NOTE: it works not like in Figma but cover our cases.
// Function above works exactly like in Figma.
function getStrokePath(payload) {
    const { type, entity, time, isPathReversed = false } = payload;
    const size = getSize(entity, time);
    const isIndividualCornersEnabled = entity.getAspectOrThrow(IndividualCornerRadiusAspect).isIndividualCornersEnabled;
    // @TODO: make it as .hasComponent check so component can be optional
    const isSmoothCornersEnabled = entity.getComponentOrThrow(SmoothCornerRadiusComponent).value;
    const rectangle = (() => {
        if (isIndividualCornersEnabled) {
            const individualCornersAspect = entity.getAspectOrThrow(IndividualCornerRadiusAspect);
            const topLeftRadius = individualCornersAspect.topLeftRadius.getValue(time);
            const topRightRadius = individualCornersAspect.topRightRadius.getValue(time);
            const bottomRightRadius = individualCornersAspect.bottomRightRadius.getValue(time);
            const bottomLeftRadius = individualCornersAspect.bottomLeftRadius.getValue(time);
            return generateRoundedRect({
                width: size.x,
                height: size.y,
                type: 'independent',
                topLeftRadius: getClampedBorderRadius({
                    width: size.x,
                    height: size.y,
                    radiusLeft: bottomLeftRadius,
                    radiusCenter: topLeftRadius,
                    radiusRight: topRightRadius,
                }),
                topRightRadius: getClampedBorderRadius({
                    width: size.x,
                    height: size.y,
                    radiusLeft: topLeftRadius,
                    radiusCenter: topRightRadius,
                    radiusRight: bottomRightRadius,
                }),
                bottomRightRadius: getClampedBorderRadius({
                    width: size.x,
                    height: size.y,
                    radiusLeft: bottomRightRadius,
                    radiusCenter: bottomLeftRadius,
                    radiusRight: topLeftRadius,
                }),
                bottomLeftRadius: getClampedBorderRadius({
                    width: size.x,
                    height: size.y,
                    radiusLeft: topRightRadius,
                    radiusCenter: bottomRightRadius,
                    radiusRight: bottomLeftRadius,
                }),
                cornerSmoothEnabled: isSmoothCornersEnabled,
            });
        }
        const cornerRadiusAspect = entity.getAspectOrThrow(CornerRadiusAspect);
        const cornerRadius = cornerRadiusAspect.radius.getValue(time);
        return generateRoundedRect({
            width: size.x,
            height: size.y,
            type: 'union',
            borderRadius: getClampedBorderRadius({
                width: size.x,
                height: size.y,
                radiusLeft: cornerRadius,
                radiusCenter: cornerRadius,
                radiusRight: cornerRadius,
            }),
            cornerSmoothEnabled: isSmoothCornersEnabled,
        });
    })();
    const rectanglePath = new paper.CompoundPath(rectangle);
    const segments = extractCurves({
        type,
        curves: rectanglePath.curves,
    }).flatMap((curve) => [curve.segment1, curve.segment2]);
    const newPath = new paper.Path(R.uniq(segments));
    if (isPathReversed) {
        newPath.reverse();
    }
    return {
        data: newPath.pathData,
        windingRule: 'NONZERO',
    };
}

const getDataMap = {
    [NodeType.Generic]: getRectangleData,
    [NodeType.BooleanOperation]: getVectorData,
    [NodeType.Rectangle]: getRectangleData,
    [NodeType.Frame]: getRectangleData,
    [NodeType.Component]: getRectangleData,
    [NodeType.Instance]: getRectangleData,
    // @TODO: provide correct path builder for groups
    [NodeType.Group]: getGroupData,
    [NodeType.Ellipse]: getEllipseData,
    [NodeType.Line]: getLineData,
    [NodeType.Polygon]: getPolygonData,
    [NodeType.Star]: getStarData,
    [NodeType.Vector]: getVectorData,
    [NodeType.Text]: getVectorData,
};
const rectangleComponents = [
    AnchorPointComponent,
    SizeComponent,
    CornerRadiusComponent,
    TopLeftCornerRadiusComponent,
    TopRightCornerRadiusComponent,
    BottomRightCornerRadiusComponent,
    BottomLeftCornerRadiusComponent,
    SmoothCornerRadiusComponent,
];
const groupComponents = [
    AnchorPointComponent,
    SizeComponent,
];
const ellipseComponents = [
    AnchorPointComponent,
    SizeComponent,
    CornerRadiusComponent,
    StartAngleComponent,
    EndAngleComponent,
    InnerRadiusComponent,
];
const lineComponents = [
    AnchorPointComponent,
    SizeComponent,
    StrokeWeightComponent,
];
const polygonComponents = [
    AnchorPointComponent,
    SizeComponent,
    PointCountComponent,
    CornerRadiusComponent,
];
const starComponents = [
    AnchorPointComponent,
    SizeComponent,
    PointCountComponent,
    InnerRadiusComponent,
    CornerRadiusComponent,
];
const vectorComponents = [
    AnchorPointComponent,
    CornerRadiusComponent,
    SizeComponent,
    VectorPathsComponent,
    SizeBehaviourComponent,
];
// @TODO: optimize the rest of node types
({
    [NodeType.Generic]: rectangleComponents,
    [NodeType.BooleanOperation]: vectorComponents,
    [NodeType.Rectangle]: rectangleComponents,
    [NodeType.Frame]: rectangleComponents,
    [NodeType.Component]: rectangleComponents,
    [NodeType.Instance]: rectangleComponents,
    // @TODO: provide correct path builder for groups
    [NodeType.Group]: groupComponents,
    [NodeType.Ellipse]: ellipseComponents,
    [NodeType.Line]: lineComponents,
    [NodeType.Polygon]: polygonComponents,
    [NodeType.Star]: starComponents,
    [NodeType.Vector]: vectorComponents,
    [NodeType.Text]: vectorComponents,
});
/**
 * **IMPORTANT**: Under the hood this function determine if path should be reversed and reverse it.
 * If you are using `isReversed` option in the data drawers then be aware of this pitfall.
 *
 * @todo update the API to make it more consistent between different functions.
 */
function getTrimmedData(payload) {
    const { data, entity, time } = payload;
    // @NOTE: required to handle path when we have open and closed paths in one string
    const preparedVectorPaths = data.flatMap((vectorPath) => {
        if (vectorPath.windingRule === 'NONZERO') {
            const splittedPath = (() => {
                const splitted = vectorPath.data.includes('Z')
                    ? vectorPath.data.split('Z')
                    : vectorPath.data.split('z');
                const shouldCloseLast = R.last(splitted) === '';
                const itemsCount = splitted.length;
                const pathsToWork = shouldCloseLast ? R.dropLast(1, splitted) : splitted;
                return pathsToWork.map((p, idx) => {
                    const isLast = idx + 1 === itemsCount;
                    if (isLast) {
                        return shouldCloseLast ? `${p}z` : p;
                    }
                    return `${p}z`;
                });
            })();
            return splittedPath.map((currentPath) => ({
                data: currentPath,
                windingRule: 'NONZERO',
            }));
        }
        return vectorPath;
    });
    if (entity.hasAspect(TrimPathAspect)) {
        const trimPathAspect = entity.getAspectOrThrow(TrimPathAspect);
        if (trimPathAspect.isEnabled) {
            const trimStart = R.clamp(0.000001, 0.999999, trimPathAspect.start.getValue(time));
            const trimEnd = R.clamp(0.000001, 0.999999, trimPathAspect.end.getValue(time));
            const trimOffset = trimPathAspect.offset.getValue(time);
            return trimPath({
                data: preparedVectorPaths,
                start: trimStart,
                end: trimEnd,
                offset: trimOffset,
                isPathReversed: entity.hasComponent(PathReversedComponent),
                // debug: true,
            });
        }
        return preparedVectorPaths;
    }
    return payload.data;
}

// @NOTE: if enable then it caused error in the svg-highlighter.
// Cannot find entity with provided id, because we are changing id in that method.
// But on the other hand if we don't change string here then svg animation is not working.
// @TODO: find the way to make it work.
function safeString(string) {
    return string;
    // return string.replace(/[^A-Za-z0-9]/g, '')
}
/**
 * @description used for svg renderer
 * @returns
 */
function mapBlendModeSvg(blendMode) {
    if (blendMode == null) {
        return 'normal';
    }
    switch (blendMode) {
        case BlendModeType$1.Darken:
            return 'darken';
        case BlendModeType$1.Multiply:
            return 'multiply';
        case BlendModeType$1.ColorBurn:
            return 'color-burn';
        case BlendModeType$1.Lighten:
            return 'lighten';
        case BlendModeType$1.Screen:
            return 'screen';
        case BlendModeType$1.ColorDodge:
            return 'color-dodge';
        case BlendModeType$1.Overlay:
            return 'overlay';
        case BlendModeType$1.SoftLight:
            return 'soft-light';
        case BlendModeType$1.HardLight:
            return 'hard-light';
        case BlendModeType$1.Difference:
            return 'difference';
        case BlendModeType$1.Exclusion:
            return 'exclusion';
        case BlendModeType$1.Hue:
            return 'hue';
        case BlendModeType$1.Saturation:
            return 'saturation';
        case BlendModeType$1.Color:
            return 'color';
        case BlendModeType$1.Luminosity:
            return 'luminosity';
        default:
            return 'normal';
    }
}
function mapPaint(payload, size) {
    const { paint, time, images } = payload;
    const paintType = paint.getComponentOrThrow(PaintTypeComponent).value;
    switch (paintType) {
        case PaintType$1.Solid: {
            return {
                id: paint.id,
                type: 'solid',
                // @TODO: provide getColor or getRgba fn
                color: getAnimatableValue(paint.getComponentOrThrow(RgbaValueComponent), time),
                visible: paint.getComponentOrThrow(VisibleInViewportComponent).value,
                blendMode: mapBlendModeSvg(paint.getComponentOrThrow(BlendModeComponent).value),
            };
        }
        case PaintType$1.GradientLinear: {
            return {
                id: paint.id,
                type: 'linear-gradient',
                visible: paint.getComponentOrThrow(VisibleInViewportComponent).value,
                gradientTransform: paint.getComponentOrThrow(GradientTransformComponent)
                    .value,
                colorStops: R.sort((left, right) => left.position - right.position, paint
                    .getAspectOrThrow(ColorStopsRelationsAspect)
                    // @TODO: sort by time
                    .getChildrenList()
                    .map((colorStop) => ({
                    // @TODO: provide getColor or getRgba fn
                    color: getAnimatableValue(colorStop.getComponentOrThrow(RgbaValueComponent), time),
                    // @TODO: provide getProgress fn
                    position: getAnimatableValue(colorStop.getComponentOrThrow(ProgressComponent), time),
                }))),
                // @TODO: add support of animation
                // opacity: paint.getAspect(LayoutAspect).opacity.getValue(time),
                opacity: paint.getComponentOrThrow(OpacityComponent).value,
                blendMode: mapBlendModeSvg(paint.getComponentOrThrow(BlendModeComponent).value),
            };
        }
        case PaintType$1.GradientRadial: {
            return {
                id: paint.id,
                type: 'radial-gradient',
                visible: paint.getComponentOrThrow(VisibleInViewportComponent).value,
                gradientTransform: paint.getComponentOrThrow(GradientTransformComponent)
                    .value,
                colorStops: R.sort((left, right) => left.position - right.position, paint
                    .getAspectOrThrow(ColorStopsRelationsAspect)
                    // @TODO: sort by time
                    .getChildrenList()
                    .map((colorStop) => ({
                    // @TODO: provide getColor or getRgba fn
                    color: getAnimatableValue(colorStop.getComponentOrThrow(RgbaValueComponent), time),
                    // @TODO: provide getProgress fn
                    position: getAnimatableValue(colorStop.getComponentOrThrow(ProgressComponent), time),
                }))),
                // @TODO: add support of animation
                // opacity: paint.getAspect(LayoutAspect).opacity.getValue(time),
                opacity: paint.getComponentOrThrow(OpacityComponent).value,
                blendMode: mapBlendModeSvg(paint.getComponentOrThrow(BlendModeComponent).value),
            };
        }
        case PaintType$1.Image: {
            return {
                id: paint.id,
                type: 'image',
                visible: paint.getComponentOrThrow(VisibleInViewportComponent).value,
                // @TODO: provide getOpacity fn?
                opacity: getAnimatableValue(paint.getComponentOrThrow(OpacityComponent), time),
                scaleMode: paint.getComponentOrThrow(ScaleTypeComponent).value,
                hash: paint.getComponentOrThrow(HashComponent).value,
                // @TODO: provide getImageTranform fn?
                imageTransform: getAnimatableValue(paint.getComponentOrThrow(ImageTransformComponent), time),
                // @TODO: add support of animation
                scalingFactor: paint.getComponentOrThrow(ScalingFactorComponent).value,
                // @TODO: provide getRotation fn?
                rotation: getAnimatableValue(paint.getComponentOrThrow(RotationComponent), time),
                blendMode: mapBlendModeSvg(paint.getComponentOrThrow(BlendModeComponent).value),
                // @TODO: add proper error handling
                // biome-ignore lint/style/noNonNullAssertion: we are sure R.head return proper value
                image: images.getImageSync(paint.getComponentOrThrow(HashComponent).value, { size }),
            };
        }
        default: {
            const never = paintType;
            throw new Error(`Should never happen: "${never}"`);
        }
    }
}
class BaseNodeSnapshot {
    entity;
    time;
    options;
    _parent;
    constructor(entity, time, options, _parent) {
        this.entity = entity;
        this.time = time;
        this.options = options;
        this._parent = _parent;
    }
    get hasAnimation() {
        if (this.hasOwnAnimation) {
            return true;
        }
        const children = this.entity.getAspect(ChildrenRelationsAspect)?.getChildrenList() ?? [];
        for (const child of children) {
            if (hasOwnAnimation(child)) {
                return true;
            }
        }
        return false;
    }
    get hasOwnAnimation() {
        return hasOwnAnimation(this.entity);
    }
    // @NOTE = base properties
    get id() {
        return safeString(this.entity.id);
    }
    get type() {
        return this.entity.getComponentOrThrow(NodeTypeComponent).value;
    }
    get name() {
        return this.entity.getComponentOrThrow(NameComponent).value;
    }
    get parent() {
        return this._parent;
    }
    get visible() {
        if (!this.entity.getComponentOrThrow(VisibleInViewportComponent).value) {
            return false;
        }
        // @TODO: move to the `@aninix-inc/model` package
        const wasTrimmedFromEnd = this.entity.hasComponent(DurationComponent);
        // @NOTE: required to properly show layers at the latest frame
        if (wasTrimmedFromEnd) {
            return (this.time >= getStartTime(this.entity) &&
                this.time < getEndTime(this.entity));
        }
        return (this.time >= getStartTime(this.entity) &&
            this.time <= getEndTime(this.entity));
    }
    get fillData() {
        const nodeType = this.entity.getComponentOrThrow(NodeTypeComponent).value;
        // const affectedComponents = getDataAffectedComponentsMap[nodeType]
        const dataDrawer = getDataMap[nodeType];
        return dataDrawer({
            entity: this.entity,
            time: this.time,
        });
    }
    // @NOTE: actually this is a trimmed data
    get data() {
        return this.options.ignoreTrimPath
            ? this.fillData
            : getTrimmedData({
                data: this.fillData,
                entity: this.entity,
                time: this.time,
            });
    }
    get individualStrokesData() {
        if (!isIndividualStrokesAvailable(this.entity) ||
            !isIndividualStrokesEnabled(this.entity)) {
            return undefined;
        }
        if (this.options.ignoreTrimPath) {
            return {
                top: getStrokePath({
                    entity: this.entity,
                    time: this.time,
                    type: 'top',
                }),
                right: getStrokePath({
                    entity: this.entity,
                    time: this.time,
                    type: 'right',
                }),
                bottom: getStrokePath({
                    entity: this.entity,
                    time: this.time,
                    type: 'bottom',
                }),
                left: getStrokePath({
                    entity: this.entity,
                    time: this.time,
                    type: 'left',
                }),
            };
        }
        return {
            top: getTrimmedData({
                data: [
                    getStrokePath({
                        entity: this.entity,
                        time: this.time,
                        type: 'top',
                    }),
                ],
                entity: this.entity,
                time: this.time,
            })[0],
            right: getTrimmedData({
                data: [
                    getStrokePath({
                        entity: this.entity,
                        time: this.time,
                        type: 'right',
                    }),
                ],
                entity: this.entity,
                time: this.time,
            })[0],
            bottom: getTrimmedData({
                data: [
                    getStrokePath({
                        entity: this.entity,
                        time: this.time,
                        type: 'bottom',
                    }),
                ],
                entity: this.entity,
                time: this.time,
            })[0],
            left: getTrimmedData({
                data: [
                    getStrokePath({
                        entity: this.entity,
                        time: this.time,
                        type: 'left',
                    }),
                ],
                entity: this.entity,
                time: this.time,
            })[0],
        };
    }
    get clipContent() {
        return this.entity.getComponent(ClipContentComponent)?.value ?? false;
    }
    get cornerRadius() {
        return (this.entity.getAspect(CornerRadiusAspect)?.radius.getValue(this.time) ?? 0);
    }
    get topLeftRadius() {
        const individualCornersAspect = this.entity.getAspect(IndividualCornerRadiusAspect);
        return individualCornersAspect?.isIndividualCornersEnabled
            ? individualCornersAspect.topLeftRadius.getValue(this.time)
            : 0;
    }
    get topRightRadius() {
        const individualCornersAspect = this.entity.getAspect(IndividualCornerRadiusAspect);
        return individualCornersAspect?.isIndividualCornersEnabled
            ? individualCornersAspect.topRightRadius.getValue(this.time)
            : 0;
    }
    get bottomRightRadius() {
        const individualCornersAspect = this.entity.getAspect(IndividualCornerRadiusAspect);
        return individualCornersAspect?.isIndividualCornersEnabled
            ? individualCornersAspect.bottomRightRadius.getValue(this.time)
            : 0;
    }
    get bottomLeftRadius() {
        const individualCornersAspect = this.entity.getAspect(IndividualCornerRadiusAspect);
        return individualCornersAspect?.isIndividualCornersEnabled
            ? individualCornersAspect.bottomLeftRadius.getValue(this.time)
            : 0;
    }
    get zIndex() {
        return this.entity.getAspectOrThrow(ZIndexAspect).getZIndex();
    }
    // @NOTE: blend properties
    get isMask() {
        return this.entity.getComponent(MaskComponent)?.value ?? false;
    }
    get blendMode() {
        return mapBlendModeSvg(this.entity.getComponentOrThrow(BlendModeComponent).value);
    }
    get lines() {
        const measureElement = document.getElementById(`measure-${this.id}`);
        if (!measureElement || !(measureElement instanceof HTMLParagraphElement))
            return [];
        const extractedLines = extractLines(measureElement);
        return extractedLines;
    }
    effects() {
        return this.entity
            .getAspectOrThrow(EffectsRelationsAspect)
            .getChildrenList()
            .filter((effect) => effect.getComponent(VisibleInViewportComponent)?.value)
            .map((effect, idx) => {
            const effectType = effect.getComponentOrThrow(EffectTypeComponent).value;
            switch (effectType) {
                case EffectType$1.DropShadow: {
                    return {
                        type: 'drop-shadow',
                        id: `${safeString(this.entity.id)}_dropShadow_${idx}`,
                        visible: effect.getComponentOrThrow(VisibleInViewportComponent)
                            .value,
                        // @TODO: replace with getShadowColor function
                        color: getAnimatableValue(effect.getComponentOrThrow(ShadowColorComponent), this.time),
                        // @TODO: replace with getShadowOffset function
                        offset: getAnimatableValue(effect.getComponentOrThrow(ShadowOffsetComponent), this.time),
                        // @TODO: replace with getShadowRadius function
                        radius: getAnimatableValue(effect.getComponentOrThrow(ShadowRadiusComponent), this.time),
                        // @TODO: replace with getShadowSpread function
                        spread: getAnimatableValue(effect.getComponentOrThrow(ShadowSpreadComponent), this.time),
                        blendMode: mapBlendModeSvg(effect.getComponentOrThrow(BlendModeComponent).value),
                    };
                }
                case EffectType$1.LayerBlur: {
                    return {
                        type: 'layer-blur',
                        id: `${safeString(this.entity.id)}_layerBlur_${idx}`,
                        // @TODO: replace with getBlurRadius function
                        radius: getAnimatableValue(effect.getComponentOrThrow(BlurRadiusComponent), this.time),
                        visible: effect.getComponentOrThrow(VisibleInViewportComponent)
                            .value,
                    };
                }
                case EffectType$1.BackgroundBlur: {
                    return {
                        type: 'background-blur',
                        id: `${safeString(this.entity.id)}_backgroundBlur_${idx}`,
                        // @TODO: replace with getBlurRadius function
                        radius: getAnimatableValue(effect.getComponentOrThrow(BlurRadiusComponent), this.time),
                        visible: effect.getComponentOrThrow(VisibleInViewportComponent)
                            .value,
                    };
                }
                case EffectType$1.InnerShadow: {
                    return {
                        type: 'inner-shadow',
                        id: `${safeString(this.entity.id)}_innerShadow_${idx}`,
                        visible: effect.getComponentOrThrow(VisibleInViewportComponent)
                            .value,
                        // @TODO: replace with getShadowColor function
                        color: getAnimatableValue(effect.getComponentOrThrow(ShadowColorComponent), this.time),
                        // @TODO: replace with getShadowOffset function
                        offset: getAnimatableValue(effect.getComponentOrThrow(ShadowOffsetComponent), this.time),
                        // @TODO: replace with getShadowRadius function
                        radius: getAnimatableValue(effect.getComponentOrThrow(ShadowRadiusComponent), this.time),
                        // @TODO: replace with getShadowSpread function
                        spread: getAnimatableValue(effect.getComponentOrThrow(ShadowSpreadComponent), this.time),
                        blendMode: mapBlendModeSvg(effect.getComponentOrThrow(BlendModeComponent).value),
                    };
                }
                default: {
                    const never = effectType;
                    throw new Error(`Should never happen: "${never}"`);
                }
            }
        });
    }
    get dropShadows() {
        return this.effects().filter((effect) => effect.type === 'drop-shadow');
    }
    get layerBlurs() {
        return this.effects().filter((effect) => effect.type === 'layer-blur');
    }
    get backgroundBlurs() {
        return this.effects().filter((effect) => effect.type === 'background-blur');
    }
    get innerShadows() {
        return this.effects().filter((effect) => effect.type === 'inner-shadow');
    }
    // @NOTE: children
    get children() {
        return (this.entity
            .getAspect(ChildrenRelationsAspect)
            ?.getChildrenList()
            .map((child) => new BaseNodeSnapshot(child, this.time, {
            imagesStore: this.options.imagesStore,
            isRoot: false,
            isStatic: this.options.isStatic,
            ignoreTrimPath: this.options.ignoreTrimPath,
        }, this)) ?? []);
    }
    get styledSegmentsFills() {
        return (this.entity
            .getAspect(StyledTextSegmentRelationsAspect)
            ?.getChildrenList()
            .map((child) => {
            const fills = child.getAspect(FillsRelationsAspect)?.getChildrenList() ?? [];
            return (fills
                // @NOTE: required to ignore images without hashes
                .filter((fill) => fill.getComponentOrThrow(PaintTypeComponent).value ===
                PaintType$1.Image
                ? fill.getComponentOrThrow(HashComponent).value !== ''
                : true)
                .map((fill) => mapPaint({
                paint: fill,
                time: this.time,
                images: this.options.imagesStore,
            }, this.imageTargetSize())));
        }) ?? []);
    }
    // @NOTE: transfor properties
    get anchorPoint() {
        return getAnchorPoint(this.entity, this.time);
    }
    get position() {
        return getPosition(this.entity, this.time);
    }
    // NOTE: negative value because figma rotate nodes counter clockwise by default
    get rotation() {
        return -getRotation(this.entity, this.time);
    }
    get opacity() {
        return getOpacity(this.entity, this.time);
    }
    get scale() {
        return getScale(this.entity, this.time);
    }
    get size() {
        return getSize(this.entity, this.time);
    }
    get skew() {
        return this.entity.getAspectOrThrow(LayoutAspect).skew.getValue(this.time);
    }
    get transformMatrix() {
        return new paper.Matrix(getTransformMatrix({
            entity: this.entity,
            time: this.time,
            ignorePosition: this.options.isRoot,
            ignoreScale: this.options.isStatic,
        }));
    }
    get absoluteTransformMatrix() {
        return new paper.Matrix(getAbsoluteTransformMatrix({
            entity: this.entity,
            time: this.time,
        }));
    }
    imageTargetSize() {
        // @NOTE: don't resize image if it's already small
        const MIN = 400;
        const originalSize = getSize(this.entity);
        if (Math.max(originalSize.x, originalSize.y) <= MIN) {
            return originalSize;
        }
        const layoutAspect = this.entity.getAspectOrThrow(LayoutAspect);
        const scaleValues = [
            this.entity.getComponentOrThrow(ScaleComponent).value,
            ...layoutAspect.scale.getKeyframeValues(),
        ];
        const maxScale = scaleValues.reduce((acc, scale) => {
            const accMax = Math.max(acc.x, acc.y);
            const scaleMax = Math.max(scale.x, scale.y);
            return accMax > scaleMax ? acc : scale;
        }, { x: 0, y: 0 });
        const sizeValues = [
            getSize(this.entity),
            ...layoutAspect.size.getKeyframeValues(),
        ];
        const maxSize = sizeValues.reduce((acc, scale) => {
            const accMax = Math.max(acc.x, acc.y);
            const scaleMax = Math.max(scale.x, scale.y);
            return accMax > scaleMax ? acc : scale;
        }, { x: 0, y: 0 });
        return {
            x: maxScale.x * maxSize.x,
            y: maxScale.y * maxSize.y,
        };
    }
    // @NOTE: geometry properties
    get fills() {
        return (this.entity
            .getAspect(FillsRelationsAspect)
            ?.getChildrenList()
            // @NOTE: required to ignore images without hashes
            .filter((fill) => fill.getComponentOrThrow(PaintTypeComponent).value === PaintType$1.Image
            ? fill.getComponentOrThrow(HashComponent).value !== ''
            : true)
            .map((fill) => mapPaint({
            paint: fill,
            time: this.time,
            images: this.options.imagesStore,
        }, this.imageTargetSize())) ?? []);
    }
    get strokes() {
        return (this.entity
            .getAspect(StrokesRelationsAspect)
            ?.getChildrenList()
            // @NOTE: required to ignore images without hashes
            .filter((fill) => fill.getComponentOrThrow(PaintTypeComponent).value === PaintType$1.Image
            ? fill.getComponentOrThrow(HashComponent).value !== ''
            : true)
            .map((stroke) => mapPaint({
            paint: stroke,
            time: this.time,
            images: this.options.imagesStore,
        }, this.imageTargetSize())) ?? []);
    }
    get strokeWeight() {
        return (this.entity.getAspect(StrokesAspect)?.strokeWeight.getValue(this.time) ??
            0);
    }
    get strokeAlign() {
        return (this.entity.getComponent(StrokeAlignComponent)?.value ??
            StrokeAlign$1.Center);
    }
    get strokeJoin() {
        return (this.entity.getComponent(StrokeJoinComponent)?.value ?? StrokeJoin$1.Miter);
    }
    get strokeCapStart() {
        return (this.entity.getComponent(StrokeCapStartComponent)?.value ?? StrokeCap$1.None);
    }
    get strokeCapEnd() {
        return (this.entity.getComponent(StrokeCapEndComponent)?.value ?? StrokeCap$1.None);
    }
    get dashOffset() {
        return this.entity.hasComponent(DashOffsetComponent)
            ? (this.entity.getAspect(StrokesAspect)?.dashOffset.getValue(this.time) ??
                0)
            : 0;
    }
    get dash() {
        return this.entity.hasComponent(DashComponent)
            ? (this.entity.getAspect(StrokesAspect)?.dash.getValue(this.time) ?? 0)
            : 0;
    }
    get gap() {
        return this.entity.hasComponent(GapComponent)
            ? (this.entity.getAspect(StrokesAspect)?.gap.getValue(this.time) ?? 0)
            : 0;
    }
    // @NOTE: individual strokes properties
    get individualStrokesEnabled() {
        return (isIndividualStrokesAvailable(this.entity) &&
            isIndividualStrokesEnabled(this.entity));
    }
    get strokeTopWeight() {
        return (this.entity
            .getAspect(IndividualStrokeWeightAspect)
            ?.top.getValue(this.time) ?? 0);
    }
    get strokeRightWeight() {
        return (this.entity
            .getAspect(IndividualStrokeWeightAspect)
            ?.right.getValue(this.time) ?? 0);
    }
    get strokeBottomWeight() {
        return (this.entity
            .getAspect(IndividualStrokeWeightAspect)
            ?.bottom.getValue(this.time) ?? 0);
    }
    get strokeLeftWeight() {
        return (this.entity
            .getAspect(IndividualStrokeWeightAspect)
            ?.left.getValue(this.time) ?? 0);
    }
    // @NOTE: helpers
    get hasMasks() {
        return this.entity.hasAspect(ChildrenRelationsAspect)
            ? R.any((child) => child.getComponentOrThrow(MaskComponent).value, this.entity
                .getAspectOrThrow(ChildrenRelationsAspect)
                .getChildrenList())
            : false;
    }
}
const convertEntityToSnapshot = (payload) => new BaseNodeSnapshot(payload.entity, payload.time, payload);

const isKeyframeBetweenCurrentAndLastTime = (keyframeTime, currentTime, lastTime) => (currentTime > lastTime &&
    keyframeTime >= lastTime &&
    keyframeTime <= currentTime) ||
    (currentTime < lastTime &&
        keyframeTime >= currentTime &&
        keyframeTime <= lastTime);

function checkVisibilityChange(entity, time, currentVisible) {
    if (entity.hasComponent(StartTimeComponent) &&
        entity.hasComponent(DurationComponent)) {
        const trimLayerStart = entity.getComponentOrThrow(StartTimeComponent).value;
        const trimLayerEnd = trimLayerStart + entity.getComponentOrThrow(DurationComponent).value;
        const isVisible = time >= trimLayerStart && time <= trimLayerEnd;
        return isVisible !== currentVisible;
    }
    return false;
}
function checkKeyframeChange(entity, time, lastTime) {
    const sortedKeyframes = getSortedKeyframes(entity);
    if (sortedKeyframes.length <= 1)
        return false;
    return sortedKeyframes.some((k) => {
        const keyframeTime = k.getComponentOrThrow(TimeComponent).value;
        return isKeyframeBetweenCurrentAndLastTime(keyframeTime, time, lastTime);
    });
}
function isTimeInAnimatedSegment(entity, time) {
    const sortedKeyframes = getSortedKeyframes(entity);
    if (sortedKeyframes.length <= 1)
        return false;
    const closestSegment = getClosestSegment(time, sortedKeyframes);
    const start = closestSegment[0].getComponentOrThrow(TimeComponent).value;
    const end = closestSegment[1].getComponentOrThrow(TimeComponent).value;
    return time >= start && time <= end;
}

const noop$1 = () => true;
function isVisibleInViewport$1(snapshot, rootSnapshot) {
    // @NOTE: faster to return layer instead of checking the whole hierarchy
    return true;
    // @TODO: add check for the whole chain of frames here
    // return isVisibleInParent(snapshot, rootSnapshot)
}
const SvgLayerOrigin$1 = React.memo(({ rootSnapshot, snapshot, shouldRender = noop$1, ignoreViewportVisibility = false, renderText = false, }) => {
    const [currentSnapshot, setCurrentSnapshot] = React.useState(snapshot);
    const snapshotRef = React.useRef(snapshot);
    const { project, imageStore } = useProjectPlaybackTime();
    const updateEntitySnapshotAtTime = (entity, time) => {
        const updatedNode = convertEntityToSnapshot({
            entity,
            //@ts-ignore
            time,
            imagesStore: imageStore,
        });
        if (updatedNode != null) {
            setCurrentSnapshot(updatedNode);
            snapshotRef.current = updatedNode;
        }
        lastTime.current = time;
    };
    const lastTime = React.useRef(0);
    React.useEffect(() => {
        const entity = project.getEntity(snapshot.id);
        const handleTimeUpdate = (event) => {
            const time = event.detail;
            if (checkVisibilityChange(entity, time, snapshotRef.current.visible)) {
                updateEntitySnapshotAtTime(entity, time);
                return;
            }
            if (checkKeyframeChange(entity, time, lastTime.current)) {
                updateEntitySnapshotAtTime(entity, time);
                return;
            }
            if (isTimeInAnimatedSegment(entity, time)) {
                updateEntitySnapshotAtTime(entity, time);
            }
            lastTime.current = time;
        };
        window.addEventListener('timeUpdate', handleTimeUpdate);
        return () => window.removeEventListener('timeUpdate', handleTimeUpdate);
    }, []);
    const shouldRenderFilter = (n) => {
        const isBelow = n.backgroundBlurs.length === 0 && n.zIndex < snapshot.zIndex;
        if (isBelow === false) {
            return false;
        }
        const providedBoundingBox = new paper.Path.Rectangle(new paper.Rectangle(new paper.Point(0, 0), new paper.Size(n.size.x, n.size.y)));
        providedBoundingBox.transform(n.absoluteTransformMatrix);
        const currentBoundingBox = new paper.Path.Rectangle(new paper.Rectangle(new paper.Point(0, 0), new paper.Size(snapshot.size.x, snapshot.size.y)));
        currentBoundingBox.transform(snapshot.absoluteTransformMatrix);
        const isIntersected = providedBoundingBox.intersects(providedBoundingBox);
        const isContain = providedBoundingBox.contains(providedBoundingBox.bounds.center);
        return isIntersected || isContain;
    };
    if (snapshotRef.current == null || snapshotRef.current.visible === false) {
        return null;
    }
    if (shouldRender(snapshotRef.current) === false) {
        return null;
    }
    if (ignoreViewportVisibility === false &&
        isVisibleInViewport$1(snapshotRef.current) === false) {
        return null;
    }
    // @NOTE: disabled because it's caused performance degradation on each render.
    // @TODO: move to snapshot to `.visible` property.
    // @NOTE: disabled layer display when it has odd matrix values.
    // Usually caused by skew parameter.
    // if (
    //   snapshot.transformMatrix.values.some((number) => Math.abs(number) > 10000)
    // ) {
    //   return null
    // }
    if (snapshot.layerBlurs.length > 0) {
        return (React.createElement(SvgLayerTransform, { node: currentSnapshot },
            React.createElement(SvgLayerBlend, { node: currentSnapshot },
                React.createElement(LayerBlur, { node: currentSnapshot, blurs: currentSnapshot.layerBlurs },
                    React.createElement(SvgLayerContent, { renderText: renderText, snapshot: currentSnapshot }, snapshotRef.current.children.map((child) => (React.createElement(SvgLayerOrigin$1, { renderText: renderText, key: `${snapshot.name}-${snapshot.id}/${child.name}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility }))))))));
    }
    if (snapshot.backgroundBlurs.length > 0 && shouldRender === noop$1) {
        return (React.createElement(SvgLayerTransform, { node: currentSnapshot },
            React.createElement(BackgroundBlur, { node: currentSnapshot, blurs: currentSnapshot.backgroundBlurs, BlurContent: React.createElement(SvgLayerOrigin$1, { renderText: renderText, rootSnapshot: rootSnapshot, snapshot: rootSnapshot, shouldRender: shouldRenderFilter, ignoreViewportVisibility: ignoreViewportVisibility }) },
                React.createElement(SvgLayerBlend, { node: currentSnapshot },
                    React.createElement(SvgLayerContent, { renderText: renderText, snapshot: currentSnapshot }, snapshotRef.current.children.map((child) => (React.createElement(SvgLayerOrigin$1, { renderText: renderText, key: `${snapshot.name}-${snapshot.id}/${child.name}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility }))))))));
    }
    if (snapshot.hasMasks) {
        // @NOTE: MASK
        const childrenGroupsByMasks = [[]];
        let maskIdx = 0;
        const childrenCount = currentSnapshot.children.length;
        for (let i = 0; i < childrenCount; i += 1) {
            const child = currentSnapshot.children[i];
            if (child.isMask) {
                maskIdx = i;
            }
            childrenGroupsByMasks.push([]);
            childrenGroupsByMasks[maskIdx].push(child);
        }
        const layers = childrenGroupsByMasks
            .filter((childrenGroupByMasks) => childrenGroupByMasks.length !== 0)
            .map((childrenGroupByMasks) => {
            const mask = R.head(childrenGroupByMasks);
            const isMaskEnabled = mask.visible && mask.isMask;
            const maskId = `${safeString$1(mask.id)}_mask`;
            if (isMaskEnabled) {
                return (React.createElement(React.Fragment, { key: childrenGroupByMasks.map((child) => child.id).join('-') },
                    React.createElement("defs", null,
                        React.createElement("mask", { id: maskId, style: {
                                maskType: 'alpha',
                            }, x: "-50%", y: "-50%", width: "200%", height: "200%" },
                            React.createElement(SvgLayerOrigin$1, { renderText: renderText, rootSnapshot: rootSnapshot, snapshot: mask, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility }))),
                    React.createElement("g", { mask: `url(#${maskId})` }, R.drop(1, childrenGroupByMasks).map((child) => (React.createElement(SvgLayerOrigin$1, { renderText: renderText, key: `${maskId}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility }))))));
            }
            return (React.createElement(React.Fragment, { key: childrenGroupByMasks.map((child) => child.id).join('-') }, childrenGroupByMasks.map((child) => (React.createElement(SvgLayerOrigin$1, { renderText: renderText, key: `${snapshot.name}-${snapshot.id}/${child.name}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility })))));
        });
        return (React.createElement(SvgLayerTransform, { node: currentSnapshot },
            React.createElement(SvgLayerBlend, { node: currentSnapshot },
                React.createElement(SvgLayerContent, { renderText: renderText, snapshot: currentSnapshot }, layers))));
    }
    return (React.createElement(SvgLayerTransform, { node: currentSnapshot },
        React.createElement(SvgLayerBlend, { node: currentSnapshot },
            React.createElement(SvgLayerContent, { renderText: renderText, snapshot: currentSnapshot }, snapshotRef.current.children.map((child) => (React.createElement(SvgLayerOrigin$1, { renderText: renderText, key: `${snapshot.name}-${snapshot.id}/${child.name}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility })))))));
});
const SmartSvgLayer = React.memo(({ time, project, imagesStore, shouldRender, ignoreViewportVisibility, renderText = false, }) => {
    const entity = project.getFirstWhere((e) => e.hasComponent(EntryComponent));
    const snapshot = React.useMemo(() => {
        return convertEntityToSnapshot({ entity, imagesStore, time });
    }, []);
    return (React.createElement(ProjectPlaybackProvider, { project: project, imageStore: imagesStore },
        React.createElement(SvgLayerOrigin$1, { renderText: renderText, snapshot: snapshot, rootSnapshot: snapshot, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility })));
}, (prev, current) => prev !== current);

const noop = () => true;
function isVisibleInViewport(snapshot, rootSnapshot) {
    // @NOTE: faster to return layer instead of checking the whole hierarchy
    return true;
    // @TODO: add check for the whole chain of frames here
    // return isVisibleInParent(snapshot, rootSnapshot)
}
const SvgLayerOrigin = React.memo(({ rootSnapshot, snapshot: providedSnapshot, shouldRender = noop, ignoreViewportVisibility = false, renderText = false, }) => {
    const [snapshot, setSnapshot] = React.useState(providedSnapshot);
    const snapshotRef = React.useRef(providedSnapshot);
    const { project, imageStore } = useProjectPlaybackTime();
    const updateEntitySnapshotAtTime = (entity, time) => {
        const updatedNode = convertEntityToSnapshot({
            entity,
            //@ts-ignore
            time,
            imagesStore: imageStore,
        });
        if (updatedNode != null) {
            setSnapshot(updatedNode);
            snapshotRef.current = updatedNode;
        }
        lastTime.current = time;
    };
    const lastTime = React.useRef(0);
    React.useEffect(() => {
        const entity = project.getEntity(snapshot.id);
        const handleTimeUpdate = (event) => {
            const time = event.detail;
            if (checkVisibilityChange(entity, time, snapshotRef.current.visible)) {
                updateEntitySnapshotAtTime(entity, time);
                return;
            }
            if (checkKeyframeChange(entity, time, lastTime.current)) {
                updateEntitySnapshotAtTime(entity, time);
                return;
            }
            if (isTimeInAnimatedSegment(entity, time)) {
                updateEntitySnapshotAtTime(entity, time);
            }
            lastTime.current = time;
        };
        window.addEventListener('timeUpdate', handleTimeUpdate);
        return () => window.removeEventListener('timeUpdate', handleTimeUpdate);
    }, []);
    React.useEffect(() => {
        const entity = project.getEntity(snapshot.id);
        return entity
            .getProjectOrThrow()
            .getSystemOrThrow(UpdatesSystem)
            .onUpdate((updates) => {
            if (updates.includes(entity.id)) {
                updateEntitySnapshotAtTime(entity, lastTime.current);
            }
        });
    }, [project]);
    const shouldRenderFilter = (n) => {
        const isBelow = n.backgroundBlurs.length === 0 && n.zIndex < snapshot.zIndex;
        if (isBelow === false) {
            return false;
        }
        const providedBoundingBox = new paper.Path.Rectangle(new paper.Rectangle(new paper.Point(0, 0), new paper.Size(n.size.x, n.size.y)));
        providedBoundingBox.transform(n.absoluteTransformMatrix);
        const currentBoundingBox = new paper.Path.Rectangle(new paper.Rectangle(new paper.Point(0, 0), new paper.Size(snapshot.size.x, snapshot.size.y)));
        currentBoundingBox.transform(snapshot.absoluteTransformMatrix);
        const isIntersected = providedBoundingBox.intersects(providedBoundingBox);
        const isContain = providedBoundingBox.contains(providedBoundingBox.bounds.center);
        return isIntersected || isContain;
    };
    if (snapshot == null || snapshot.visible === false) {
        return null;
    }
    if (shouldRender(snapshot) === false) {
        return null;
    }
    if (ignoreViewportVisibility === false &&
        isVisibleInViewport() === false) {
        return null;
    }
    // @NOTE: disabled because it's caused performance degradation on each render.
    // @TODO: move to snapshot to `.visible` property.
    // @NOTE: disabled layer display when it has odd matrix values.
    // Usually caused by skew parameter.
    // if (
    //   snapshot.transformMatrix.values.some((number) => Math.abs(number) > 10000)
    // ) {
    //   return null
    // }
    if (snapshot.layerBlurs.length > 0) {
        return (React.createElement(SvgLayerTransform, { node: snapshot },
            React.createElement(SvgLayerBlend, { node: snapshot },
                React.createElement(LayerBlur, { node: snapshot, blurs: snapshot.layerBlurs },
                    React.createElement(SvgLayerContent, { renderText: renderText, snapshot: snapshot }, snapshot.children.map((child) => (React.createElement(SvgLayerOrigin, { renderText: renderText, key: `${snapshot.name}-${snapshot.id}/${child.name}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility }))))))));
    }
    if (snapshot.backgroundBlurs.length > 0 && shouldRender === noop) {
        return (React.createElement(SvgLayerTransform, { node: snapshot },
            React.createElement(BackgroundBlur, { node: snapshot, blurs: snapshot.backgroundBlurs, BlurContent: React.createElement(SvgLayerOrigin, { renderText: renderText, rootSnapshot: rootSnapshot, snapshot: rootSnapshot, shouldRender: shouldRenderFilter, ignoreViewportVisibility: ignoreViewportVisibility }) },
                React.createElement(SvgLayerBlend, { node: snapshot },
                    React.createElement(SvgLayerContent, { renderText: renderText, snapshot: snapshot }, snapshot.children.map((child) => (React.createElement(SvgLayerOrigin, { renderText: renderText, key: `${snapshot.name}-${snapshot.id}/${child.name}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility }))))))));
    }
    if (snapshot.hasMasks) {
        // @NOTE: MASK
        const childrenGroupsByMasks = [[]];
        let maskIdx = 0;
        const childrenCount = snapshot.children.length;
        for (let i = 0; i < childrenCount; i += 1) {
            const child = snapshot.children[i];
            if (child.isMask) {
                maskIdx = i;
            }
            childrenGroupsByMasks.push([]);
            childrenGroupsByMasks[maskIdx].push(child);
        }
        const layers = childrenGroupsByMasks
            .filter((childrenGroupByMasks) => childrenGroupByMasks.length !== 0)
            .map((childrenGroupByMasks) => {
            const mask = R.head(childrenGroupByMasks);
            const isMaskEnabled = mask.visible && mask.isMask;
            const maskId = `${safeString$1(mask.id)}_mask`;
            if (isMaskEnabled) {
                return (React.createElement(React.Fragment, { key: childrenGroupByMasks.map((child) => child.id).join('-') },
                    React.createElement("defs", null,
                        React.createElement("mask", { id: maskId, style: {
                                maskType: 'alpha',
                            }, x: "-50%", y: "-50%", width: "200%", height: "200%" },
                            React.createElement(SvgLayerOrigin, { renderText: renderText, rootSnapshot: rootSnapshot, snapshot: mask, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility }))),
                    React.createElement("g", { mask: `url(#${maskId})` }, R.drop(1, childrenGroupByMasks).map((child) => (React.createElement(SvgLayerOrigin, { renderText: renderText, key: `${maskId}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility }))))));
            }
            return (React.createElement(React.Fragment, { key: childrenGroupByMasks.map((child) => child.id).join('-') }, childrenGroupByMasks.map((child) => (React.createElement(SvgLayerOrigin, { renderText: renderText, key: `${snapshot.name}-${snapshot.id}/${child.name}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility })))));
        });
        return (React.createElement(SvgLayerTransform, { node: snapshot },
            React.createElement(SvgLayerBlend, { node: snapshot },
                React.createElement(SvgLayerContent, { renderText: renderText, snapshot: snapshot }, layers))));
    }
    return (React.createElement(SvgLayerTransform, { node: snapshot },
        React.createElement(SvgLayerBlend, { node: snapshot },
            React.createElement(SvgLayerContent, { renderText: renderText, snapshot: snapshot }, snapshot.children.map((child) => (React.createElement(SvgLayerOrigin, { renderText: renderText, key: `${snapshot.name}-${snapshot.id}/${child.name}-${child.id}`, rootSnapshot: rootSnapshot, snapshot: child, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility })))))));
}, () => true);
const DumbSvgLayer = React.memo(({ time, project, imagesStore, shouldRender, ignoreViewportVisibility, renderText = false, }) => {
    const entity = project.getFirstWhere((e) => e.hasComponent(EntryComponent));
    const snapshot = convertEntityToSnapshot({ entity, imagesStore, time });
    return (React.createElement(ProjectPlaybackProvider, { project: project, imageStore: imagesStore },
        React.createElement(SvgLayerOrigin, { renderText: renderText, snapshot: snapshot, rootSnapshot: snapshot, shouldRender: shouldRender, ignoreViewportVisibility: ignoreViewportVisibility })));
}, () => true);

const usePostTime = (time) => {
    React.useEffect(() => {
        window.dispatchEvent(new CustomEvent('timeUpdate', { detail: time }));
    }, [time]);
};

/**
 * Root-sized component for displaying snapshot in 1:1 scale
 */
const Viewbox = ({ snapshot, renderText = false, injectCss, }) => {
    const viewBox = `0 0 ${snapshot.size.x} ${snapshot.size.y}`;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: `${snapshot.size.x}px`, height: `${snapshot.size.y}px`, viewBox: viewBox },
        injectCss && React.createElement("style", { dangerouslySetInnerHTML: { __html: injectCss } }),
        React.createElement(SvgLayer, { snapshot: snapshot, rootSnapshot: snapshot, renderText: renderText })));
};
Viewbox.displayName = 'Viewbox';

function stringifiedSvgToImage(payload) {
    const { stringifiedSvg, size, format, quality } = payload;
    return new Promise((resolve, reject) => {
        const canvas = new OffscreenCanvas(size.x, size.y);
        const context = canvas.getContext('2d');
        if (context == null) {
            throw new Error('invalid state');
        }
        const svgUrl = `data:image/svg+xml,${encodeURIComponent(stringifiedSvg)}`;
        const svgImage = new Image(size.x, size.y);
        svgImage.onload = async () => {
            context.drawImage(svgImage, 0, 0, size.x, size.y);
            const blob = await canvas.convertToBlob({
                type: format,
                quality,
            });
            if (blob == null) {
                reject(new Error('Blob cannot be generated'));
                svgImage.remove();
                return;
            }
            resolve(blob);
            svgImage.remove();
        };
        svgImage.onerror = () => {
            reject(new Error('Error loading SVG image'));
            svgImage.remove();
        };
        svgImage.src = svgUrl;
    });
}

const renderAsImage = ({ snapshot, format = 'png', size = 'auto', quality = 0.8, injectCss, }) => {
    const svg = renderToStaticMarkup(React.createElement(Viewbox, { snapshot: snapshot, renderText: true, injectCss: injectCss }));
    return stringifiedSvgToImage({
        stringifiedSvg: svg,
        size: (size === 'auto' ? { ...snapshot.size } : size),
        format: `image/${format}`,
        quality: quality,
    });
};
const renderAsPng = (args) => {
    return renderAsImage({ ...args, format: 'png' });
};
const renderAsWebp = (args) => {
    return renderAsImage({ ...args, format: 'webp' });
};
const renderAsJpeg = (args) => {
    return renderAsImage({ ...args, format: 'jpeg' });
};

class Logger {
    payload;
    constructor(payload) {
        this.payload = payload;
    }
    log = (...args) => {
        if (this.payload.debug) {
            if (this.payload.prefix) {
                console.log(this.payload.prefix, ...args);
                return this;
            }
            console.log(...args);
        }
        return this;
    };
    warn = (...args) => {
        if (this.payload.debug) {
            if (this.payload.prefix) {
                console.warn(this.payload.prefix, ...args);
                return this;
            }
            console.warn(...args);
            return this;
        }
        return this;
    };
    error = (...args) => {
        if (this.payload.debug) {
            if (this.payload.prefix) {
                console.error(this.payload.prefix, ...args);
                return this;
            }
            console.error(...args);
            return this;
        }
        return this;
    };
}

const getStringifiedSvg = (snapshot) => renderToStaticMarkup(React.createElement(Viewbox, { snapshot: snapshot }));

let logger;
function renderOnCanvas(payload) {
    const { snapshot, size = { ...snapshot.size }, canvas, debug } = payload;
    if (logger === undefined) {
        logger = new Logger({ debug, prefix: '[renderOnCanvas]' });
    }
    logger.log('snapshot');
    const stringifiedSvg = getStringifiedSvg(snapshot);
    logger.log('stringified', stringifiedSvg);
    return new Promise((resolve, reject) => {
        const context = canvas.getContext('2d');
        logger.log('context', context);
        if (context == null) {
            throw new Error('invalid state');
        }
        logger.log('rendering');
        const svgUrl = `data:image/svg+xml,${encodeURIComponent(stringifiedSvg)}`;
        const svgImage = new Image(size.x, size.y);
        logger.log('image', svgImage);
        svgImage.addEventListener('load', () => {
            logger.log('loaded');
            context.drawImage(svgImage, 0, 0, size.x, size.y);
            resolve();
        });
        svgImage.addEventListener('error', (error) => {
            logger.error('err', error);
            reject(new Error('Error loading SVG image'));
            svgImage.remove();
        });
        svgImage.src = svgUrl;
        logger.log('reach the end');
    });
}

export { DumbSvgLayer, MeasureParagraph, PaperOffset, SmartSvgLayer, SvgLayer, convertEntityToSnapshot, createTextStyle, extractSegmentMeta, getDataMap, getStringifiedSvg, getStrokePath, loadInlineFonts, renderAsJpeg, renderAsPng, renderAsWebp, renderOnCanvas, usePostTime };
//# sourceMappingURL=index.esm.js.map
